import { NSFunctions } from './utils/functions';
import { NSDateDatetime } from './utils/date_datetime';
import { xCore, xCoreHelper } from './core';
import { Map as Module_Map } from './map';
import { URN as NSURN } from './utils/urn';
import { NSMessages } from './utils/messages';
import { NSTables } from './utils/tables';
import { NSCombos } from './utils/combos'
import { NSDataTypes } from './utils/data_types';
import { NSDataModelInfo } from './data_model_info';
import { NSToolDraw } from './tool_draw';
import { NSPageSidepanel } from './page_sidepanel';
import { NSServerCalls } from './utils/servercalls';
import { NSObjDetailsGeo } from './obj_details_geo';
import { NSGeoJson } from './utils/geojson';
import { Overlays } from './overlays';
import { NSUserFunctionPermissions } from './user_function_permissions';
import { NSResultsInterface } from './results_interface';
import { NSPageLabels } from './page_labels';
 
import ArrowLeftIcon from 'bootstrap-icons/icons/arrow-left.svg?raw';
import DownloadIcon from 'bootstrap-icons/icons/download.svg?raw';
import EraserFillIcon from 'bootstrap-icons/icons/eraser-fill.svg?raw';

import PencilFillIcon from 'bootstrap-icons/icons/pencil-fill.svg?raw';
import PlusIcon from 'bootstrap-icons/icons/plus-lg.svg?raw';
import DashIcon from 'bootstrap-icons/icons/dash.svg?raw';
import CheckIcon from 'bootstrap-icons/icons/check-lg.svg?raw';
import CloseIcon from 'bootstrap-icons/icons/x-lg.svg?raw';
import PasteIcon from 'bootstrap-icons/icons/clipboard.svg?raw';
import { NSObjDetailsCloneData } from './obj_details_clone_data';
import { NSGeometryClipboard } from './geometry_clipboard.js'

import GeoJSON from 'ol/format/GeoJSON'; 

export let NSObjDetailsEdit = {};

NSObjDetailsEdit.init = function()
{
    NSObjDetailsEditPrivate.init();

    this.f_edit_details = 	    function () { return NSObjDetailsEditPrivate.f_edit_details.apply( NSObjDetailsEditPrivate, arguments ); };
    this.f_hide_edit_section = 	function () { return NSObjDetailsEditPrivate.f_hide_edit_section.apply( NSObjDetailsEditPrivate, arguments ); };

    this.f_edit_section_is_active =		function () { return NSObjDetailsEditPrivate.f_edit_section_is_active.apply( NSObjDetailsEditPrivate, arguments ); };
    this.f_get_urn_of_obj_in_edition = 	function () { return NSObjDetailsEditPrivate.f_get_urn_of_obj_in_edition.apply( NSObjDetailsEditPrivate, arguments ); };

    window.NSObjDetailsEdit = NSObjDetailsEdit;
	//window.NSObjDetailsEdit_ = NSObjDetailsEdit;
	window.NSObjDetailsEditPrivate_ = NSObjDetailsEditPrivate;
}

let NSObjDetailsEditPrivate = {
    private_objs: 
	{
		settings: null, //config settings
		
		s_e_div_editorpage_holder_id: "editorpage",
		s_e_div_edit_id: "editorpage_edit",
		
		e_div_editorpage_holder: null,
		e_editorpage_edit: null,
		
		e_div_table_edit_holder: null,
		e_button_obj_details_edit_save: null,
		e_button_obj_details_edit_delete: null,
		e_button_obj_details_edit_cancel: null,
		
		e_div_edit_save_loading: null,
		
		
		
		e_span_obj_details_edit_title: null,
		
		
		
		o_details: null,
		
		o_details_edit: null,		// {NSObjDetailsEditPrivate.objs.ObjInfo}
		
		s_urn_parent: null,			// stores the parent urn, when creating a join child...
		o_parent_geometry: null,	// stores the parent geometry, when creating a join child...

        o_geo_highlight: null, 		//	{NSObjDetailsGeo_.objs.GeoHighlight}
		

		
		
	},
 
	
	init: function()
	{
		let this_ = this;
		let private_objs = this.private_objs;
		
		this.objs.init();
		
		
		let moduleName = "NSObjDetailsEdit";
		//private_objs.settings = xCore.loader.modules[moduleName].settings;
        private_objs.settings = xCore.modules[moduleName].settings;
		
        private_objs.o_geo_highlight = new NSObjDetailsGeo.objs.GeoHighlight();
		
		private_objs.e_div_editorpage_holder = document.getElementById(private_objs.s_e_div_editorpage_holder_id);
		private_objs.e_editorpage_edit = document.getElementById(private_objs.s_e_div_edit_id);
		
		let s_label_obj_details_edit_button_back_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_button_back_tooltip");
		let s_label_obj_details_edit_button_save_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_button_save_tooltip");
		let s_label_obj_details_edit_button_delete_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_button_delete_tooltip");

		let e_editorpage_edit = private_objs.e_editorpage_edit;
		e_editorpage_edit.innerHTML = `
			<div class="actions-buttons-group btn-group btn-group-sm" role="group" aria-label="...">
				<button id="button_obj_details_edit_cancel" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_obj_details_edit_button_back_tooltip}">${ArrowLeftIcon}</button>
				<button id="button_obj_details_edit_save" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_obj_details_edit_button_save_tooltip}">${DownloadIcon}</button>
				<button id="button_obj_details_edit_delete" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_obj_details_edit_button_delete_tooltip}">${EraserFillIcon}</button>
			</div>
			<div class="editor-title">
				<div id="div_edit_save_loading" class="spinner-border text-danger" role="status"></div>
			</div>
			<div class="table-container"></div>
		`;
		
		private_objs.e_div_table_edit_holder = e_editorpage_edit.querySelector(".table-container");
		private_objs.e_button_obj_details_edit_save = e_editorpage_edit.querySelector("#button_obj_details_edit_save");
		private_objs.e_button_obj_details_edit_delete = e_editorpage_edit.querySelector("#button_obj_details_edit_delete");
		private_objs.e_button_obj_details_edit_cancel = e_editorpage_edit.querySelector("#button_obj_details_edit_cancel");
		
//		private_objs.e_button_obj_details_edit_save.setAttribute("style", "display: none;")
		
		private_objs.e_div_edit_save_loading = e_editorpage_edit.querySelector("#div_edit_save_loading");
		
		
		private_objs.e_span_obj_details_edit_title = e_editorpage_edit.querySelector(".editor-title");
		
		
		private_objs.e_button_obj_details_edit_save.onclick = function ()
		{
				this_.o_edit.f_execute_save();
		}
		
		private_objs.e_button_obj_details_edit_delete.onclick = function ()
		{
				this_.o_edit.f_execute_delete();
		}
		
		private_objs.e_button_obj_details_edit_cancel.onclick = function ()
		{
				this_.o_edit.f_execute_cancel();
		}

		
		NSObjDetailsEditPrivate.f_hide_edit_section();
		
	},
	
	f_show_edit_section: function()
	{
		var private_objs = this.private_objs;
		
		NSObjDetails.f_hide_read_section();
		
		private_objs.e_editorpage_edit.style.display = "";
	},
	f_hide_edit_section: function()
	{
		let private_objs = this.private_objs;
		private_objs.o_geo_highlight.f_remove_all();
		private_objs.e_editorpage_edit.style.display = "none";

		Module_Map.state.f_set_switch_parent(false);
	},
	
	f_show_hide_table_edit: function (b_show_table)
	{
		var private_objs = this.private_objs;
		
		//AQUIIII TO DO TODO
	},
	
	f_edit_section_is_visible: function ()
	{
		var private_objs = this.private_objs;
		var b_is_visible = (private_objs.e_editorpage_edit.style.display == "none")? false : true;
		return b_is_visible;
	},
	
	f_edit_section_is_active: function ()
	{
		var private_objs = this.private_objs;
		var b_is_visible = this.f_edit_section_is_visible();
		var b_edit_section_is_active = b_is_visible;
		return b_edit_section_is_active;
	},
	f_get_urn_of_obj_in_edition: function ()
	{
		var private_objs = this.private_objs;
		var o_details_edit = private_objs.o_details_edit;
		var s_urn = ( o_details_edit != null )? o_details_edit.s_urn : null;
		return s_urn;
	},
	/*
	
	//o_obj_details like the one in "obj_details.js"
	o_obj_details = {
        ...
	};
	
	s_urn_parent: stores the urn of the parent object, when creating a join child
	*/
	f_add_copy_checkbox: function()
	{
		const button = $(`<button id="button_obj_details_edit_copy" type="button" class="btn btn-sm btn-outline-secondary" data-bs-toggle="button">Copiar</button>`);

		$(`#${this.private_objs.s_e_div_edit_id} .actions-buttons-group`).append(button);
	},
	f_remove_copy_button: function()
	{
		$('#button_obj_details_edit_copy').remove();
	},
	f_edit_details: function (o_details, s_urn_parent, o_parent_geometry)
	{
		
		//this.f_clean();
		
		let this_ = this;
		
		this.o_edit_elements_state_functions.f_set_blocked_state();
		
		let s_feature_urn = o_details.s_urn;
		let s_table_urn = NSURN.f_create_table_urn_from_record_urn(s_feature_urn);

		
        let o_promise = NSDataModelInfo.f_load_table____returning_promise({			
            b_full_info: true,
            s_table_urn: s_table_urn
        });

        o_promise
        .then(function(b_error, s_message) 
        {
            this_.f_edit_details_part_2(o_details, s_urn_parent, o_parent_geometry);
        })
        .catch(err => { 
            console.log(err);

        });


		
		
	},
	f_edit_details_part_2: function(o_details, s_urn_parent, o_parent_geometry)
	{
		this.private_objs.o_details = o_details;
	
		this.private_objs.o_details_edit = new NSObjDetailsEditPrivate.objs.ObjInfo(o_details);
		
		this.private_objs.s_urn_parent = s_urn_parent;
		this.private_objs.o_parent_geometry = o_parent_geometry;
		
		this.o_edit_elements_state_functions.f_set_initial_state();
	
		this.f_set_title();
		
		this.o_edit.f_edit_details();
		
		this.f_show_edit_section();

		this.f_remove_copy_button();

		let s_table_urn = NSURN.f_create_table_urn_from_record_urn(o_details.s_urn);
		if (NSObjDetailsEditPrivate.f_editor_is_in_creation_mode() && NSObjDetailsCloneData.f_is_eligible(s_table_urn)) this.f_add_copy_checkbox();
	},
	
	f_set_title: function ()
	{
		var private_objs = this.private_objs;
		
		var o_details = private_objs.o_details;
		var s_feature_urn = o_details.s_urn;
		var a_feature_urn_info = NSURN.f_get_urn_info(s_feature_urn);
		var s_schema_internal_name = a_feature_urn_info[1];
		var s_table_internal_name = a_feature_urn_info[2];
		
        var o_col_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);

		private_objs.e_span_obj_details_edit_title.querySelectorAll('*:not(#div_edit_save_loading)').forEach((el) => el.remove());;

		NSFunctions.f_dom_elem_preappend_dom_childs_by_html(private_objs.e_span_obj_details_edit_title, `<div>${o_col_info.external_name || ''}</div>`, '#div_edit_save_loading');
	},
	
	f_editor_is_in_creation_mode: function() 
	{
		var s_obj_urn = NSObjDetailsEditPrivate.private_objs.o_details_edit.s_urn;
		var b_urn_is_for_creation = NSObjDetailsCreate.f_urn_is_for_creation(s_obj_urn); 
		return b_urn_is_for_creation;
	},
	
	o_edit_elements_state_functions: 
	{
		f_set_blocked_state: function()
		{
			
			this.f_button_save_disable();
			this.f_button_delete_disable();
			this.f_button_cancel_disable();
			this.f_hide_save_loading();
		},	

		f_set_initial_state: function()
		{

			var b_urn_is_for_creation = NSObjDetailsEditPrivate.f_editor_is_in_creation_mode();
			
			
			this.f_button_save_enable();
			if(b_urn_is_for_creation) //insert
			{
				// this.f_button_delete_hide();
			}
			else
			{
				this.f_button_delete_enable();
				// this.f_button_delete_show();
			}
			this.f_button_cancel_enable();
			this.f_hide_save_loading();
		},			
		
		f_button_save_is_enabled: function()
		{
			var e_button_obj_details_edit_save = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_save;
			var s_ = "disabled";
			var b_is_enabled = (e_button_obj_details_edit_save.hasAttribute(s_) == true)? false : true;
			
			return b_is_enabled;
		},
		f_button_save_enable: function()
		{
			var e_button_obj_details_edit_save = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_save;
			
			var s_ = "disabled";
			e_button_obj_details_edit_save.removeAttribute(s_);
			
		},
		f_button_save_disable: function()
		{
			var e_button_obj_details_edit_save = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_save;

			var s_ = "disabled";
			e_button_obj_details_edit_save.setAttribute(s_, s_);
			
			
		},
		f_button_delete_is_enabled: function()
		{
			var e_button_obj_details_edit_delete = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_delete;
			var s_ = "disabled";
			var b_is_enabled = (e_button_obj_details_edit_delete.hasAttribute(s_) == true)? false : true;
			
			return b_is_enabled;
		},
		f_button_delete_enable: function()
		{
			var e_button_obj_details_edit_delete = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_delete;
			
			var s_ = "disabled";
			e_button_obj_details_edit_delete.removeAttribute(s_);
			
		},
		f_button_delete_disable: function()
		{
			var e_button_obj_details_edit_delete = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_delete;

			var s_ = "disabled";
			e_button_obj_details_edit_delete.setAttribute(s_, s_);
		},
		f_button_delete_show: function()
		{
			var e_button_obj_details_edit_delete = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_delete;

			var b_is_displayed = true;			
			NSObjDetailsEditPrivate.o_button_struct.f_set_button_displayed_state(e_button_obj_details_edit_delete, b_is_displayed)
			
			
		},
		f_button_delete_hide: function()
		{
			var e_button_obj_details_edit_delete = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_delete;

			var b_is_displayed = false;			
			NSObjDetailsEditPrivate.o_button_struct.f_set_button_displayed_state(e_button_obj_details_edit_delete, b_is_displayed)
			
			
		},
		f_button_cancel_is_enabled: function()
		{
			var e_button_obj_details_edit_cancel = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_cancel;
			var s_ = "disabled";
			var b_is_enabled = (e_button_obj_details_edit_cancel.hasAttribute(s_) == true)? false : true;
			
			return b_is_enabled;
		},
		f_button_cancel_enable: function()
		{
			var e_button_obj_details_edit_cancel = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_cancel;
			
			var s_ = "disabled";
			e_button_obj_details_edit_cancel.removeAttribute(s_);
			
		},
		f_button_cancel_disable: function()
		{
			var e_button_obj_details_edit_cancel = NSObjDetailsEditPrivate.private_objs.e_button_obj_details_edit_cancel;

			var s_ = "disabled";
			e_button_obj_details_edit_cancel.setAttribute(s_, s_);
			
			
		},
		
		f_show_save_loading: function()
		{
			NSObjDetailsEditPrivate.private_objs.e_div_edit_save_loading.style.display = "";
		},
		f_hide_save_loading: function()
		{
			NSObjDetailsEditPrivate.private_objs.e_div_edit_save_loading.style.display = "none";
		},
		
	},
	
	o_delete_struct: {

		f_show_dialog: function()
		{
			let this_ = this;
			
			let f_cb_ok = function()
			{
				this_.f_click_ok();
			};
			let f_cb_cancel = function()
			{
				this_.f_click_cancel();
			};

			NSConfirm.f_show({
				s_title_text: "Remoção de Objecto",
						s_button_ok_text: "Confirmar",
						s_button_cancel_text: "Cancelar",
						s_text: "Tem a certeza de que pretende remover o objecto?",
						f_on_ok_cb: f_cb_ok,
						f_on_cancel_cb: f_cb_cancel
				});
		},

		f_click_ok: function()
		{
			
			//NSObjDetails.f_hide_read_and_edit_section();
			
			
			let this_ = this;
			
			let o_details_edit = NSObjDetailsEditPrivate.private_objs.o_details_edit; 					// {NSObjDetailsEditPrivate.objs.ObjInfo}
			let a_field_edit_struct = NSObjDetailsEditPrivate.o_edit.private_objs.a_field_edit_struct;	//[{NSObjDetailsEditPrivate.objs.FieldEdit}]

			let s_obj_urn = o_details_edit.s_urn;
			let s_table_urn = NSURN.f_create_table_urn_from_record_urn(s_obj_urn);
			
			let o_edit_elements_state_functions = NSObjDetailsEditPrivate.o_edit_elements_state_functions;
		
			o_edit_elements_state_functions.f_show_save_loading();


			// preparing input for possible tiles update

			let b_table_has_geometry = NSDataModelInfo.f_table_has_geometry_by_urn(s_table_urn);

			//preparing call
			let f_cb = function(o_resp)
			{
				this_.f_delete_object_process_result_(o_resp);
			}

			
			let s_record_id = NSURN.f_get_urn_record_id(s_obj_urn);
			
			let o_delete_in = {
				"table_urn": s_table_urn,
				"id": s_record_id
			};

			NSServerCalls.f_edit_obj_delete(o_delete_in, f_cb);
			
			
		},
		f_delete_object_process_result_: function (o_resp)
		{
			
			var o_edit_elements_state_functions = NSObjDetailsEditPrivate.o_edit_elements_state_functions;
			

			if( o_resp != null && o_resp.success == true )
			{
				NSObjDetails.f_hide_read_and_edit_section();
				

				var o_details = NSObjDetailsEditPrivate.private_objs.o_details;
				var o_details_edit = NSObjDetailsEditPrivate.private_objs.o_details_edit;

				let s_table_urn = NSURN.f_create_table_urn_from_record_urn(o_details.s_urn)

				Overlays.f_refresh_layers_by_table_urn(s_table_urn);
				NSResultsInterface.f_clean_results_interface();
				
			}
			else
			{
				//o_resp.error
				var s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_delete_message");
				NSMessages.f_show_information(s_message);
				
				o_edit_elements_state_functions.f_set_initial_state();
				
				return;
			}
			
			
			
		},
		f_click_cancel: function()
		{
			var o_edit_elements_state_functions = NSObjDetailsEditPrivate.o_edit_elements_state_functions;
			
			o_edit_elements_state_functions.f_set_initial_state();
			this.f_hide();
			
		}
		
	},
	
	o_edit: 
	{
		private_objs: 
		{
			//e_div_table: null,
			
			o_table: null,
			
			table_data:
			{
				a_column_name: null
			},
			
			a_column_value_holder_div: null,
			
			a_field_edit_struct: null, //[{NSObjDetailsEditPrivate.objs.FieldEdit}]
		
		},
		
		f_edit_details: function ()
		{
			var private_objs = NSObjDetailsEditPrivate.private_objs;
			
			var o_details = private_objs.o_details;
			var o_details_edit = private_objs.o_details_edit;
			
			this.f_create_details_edit_content();
			
			NSPageSidepanel.f_enable_editortool();
			NSPageSidepanel.f_show_sidepanel();
			
			
		},
		
		f_create_details_edit_content: function()
		{
			var private_objs_global = NSObjDetailsEditPrivate.private_objs;
			
			//var o_details = private_objs_global.o_details;
			var o_details_edit = private_objs_global.o_details_edit;
			
			this.f_initialize_table();
			
			this.f_fill_table();
			
			
		},
		
		f_initialize_table: function()
		{	
			var this_ = this;
			var private_objs = this.private_objs;
			var private_objs_global = NSObjDetailsEditPrivate.private_objs;
			
			//	field_name, field_value
			var a_column_name = ["Propriedade", "Valor"];
			var aTH_CSS = [];
			var aTD_CSS = [];
			for(var i=0; i<a_column_name.length; i++)
			{
				aTH_CSS.push("details-table-cell")
				aTD_CSS.push("details-table-cell")
			}
			
			private_objs.table_data.a_column_name = a_column_name;
			
			if(private_objs.o_table != null)
			{
				private_objs.o_table.destroy();
				private_objs.o_table = null;
			}
			
			
			//table sort comparisson function
			var f_cmp_sel = function(o1,o2)
			{
				return NSFunctions.o_comparisson_struct.f_cmp_sel(o1,o2);
			}
			var f_cmp_input_cb = function(o1,o2)
			{
				return NSFunctions.o_comparisson_struct.f_cmp_input_cb(o1,o2);
			}
			var f_cmp_string = function(o1,o2)
			{
				return NSFunctions.o_comparisson_struct.f_cmp_string(o1,o2);
			}
			
			
			var aColumns = new Array();
			aColumns = aColumns.concat(a_column_name)

			var e_TableHolder = private_objs_global.e_div_table_edit_holder;         
			var sTableCSS = 'table table-sm table-bordered table-hover table-col-1-nowrap';//'table table-bordered table-striped table-hover';
			var sTR_CSS = [""];
			var sTR_SELECTED_CSS = "selected";//"active_tr";//"active";//"table_tr_selected";
			var b_multiple_selection = false;
			var b_multiple_selection_classic_style = true;
			var b_sortable = true;
			var a_b_col_sortable = [true, false];//null;
			//var a_sort_cmp_function = null;
			var a_sort_cmp_function = [f_cmp_string, f_cmp_string];
			
			
			var o_in = {
				eHTMLHolder: e_TableHolder, 
				aColumns: aColumns, 
				sTableCSS: sTableCSS, 
				aTH_CSS: aTH_CSS, 
				aTD_CSS: aTD_CSS, 
				sTR_CSS: sTR_CSS, 
				sTR_SELECTED_CSS: sTR_SELECTED_CSS, 
				b_multiple_selection: b_multiple_selection, 
				b_multiple_selection_classic_style: b_multiple_selection_classic_style,
				b_sortable: b_sortable,
				a_b_col_sortable: a_b_col_sortable,    // default b_sortable determines if all are sortable or not
				a_sort_cmp_function: a_sort_cmp_function, //    ->  a[f(o1,o2)]    -> f returns true if o1 < o2 , default string comparisson...
			};
			
			var table = new NSTables.Objs.Table(o_in);
			private_objs.o_table = table;	
			
			//------------------------------------------
			//Event Handlers:
			//table
			var this_ = this;
			table.addRowClickEventFunction(
				function () {
				  //alert("row selected!");
				  this_.f_table_on_select_handler_();
			});
			
			//refreshing visibility:
			var b_show_table =  (a_column_name.length > 0)? true: false;
			NSObjDetailsEditPrivate.f_show_hide_table_edit(b_show_table);

		},
		
		f_table_on_select_handler_: function()
		{
			var private_objs = this.private_objs;
			var o_table = private_objs.o_table;
			var a_selected_keys = o_table.getSelection_keys();
			//key -> obj_details_table_read_row__ + s_field_i_external_name
			
			
		},
		f_fill_table: function()
		{
			let private_objs = this.private_objs;
			let private_objs_global = NSObjDetailsEditPrivate.private_objs;

			let o_details_edit = private_objs_global.o_details_edit;
			let o_feature = o_details_edit.feature;
			let s_feature_urn = o_details_edit.s_urn;
			let a_feature_urn_info = NSURN.f_get_urn_info(s_feature_urn);
			let s_schema_internal_name = a_feature_urn_info[1];
			let s_table_internal_name = a_feature_urn_info[2];
			
            
			let o_col_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);


			var table_data = new NSTables.Objs.DataTable();
			var a_column_name = private_objs.table_data.a_column_name;
			
            
			var o_properties_complete = o_feature.properties_complete;
			var a_properties_keys = o_col_info.extra.a_ordered_visible_columns;
			
			var a_column_value_holder_div = [];
			private_objs.a_column_value_holder_div = a_column_value_holder_div;
			
			for(let i=0; i<a_properties_keys.length; i++)
			{
				let s_key_i = a_properties_keys[i];
				let s_field_i_internal_name = s_key_i;
				let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_i_internal_name);
                let s_field_i_internal_name_db = o_field_info_i.internal_name_db;
				let s_field_i_external_name = o_field_info_i.external_name;
				
				let s_field_i_value = o_properties_complete[s_field_i_external_name];
				
				/*
				s_schema_internal_name
				s_table_internal_name
				s_field_i_internal_name
				s_field_i_external_name
				*/
				
				let b_field_is_join_field = o_field_info_i.is_join;
				let b_field_is_editable = o_field_info_i.editable;
				
				if(b_field_is_editable || b_field_is_join_field)
				{

					let s_div_value_holder_key = NSFunctions.guidGenerator();
					a_column_value_holder_div.push(s_div_value_holder_key);
					
                    let s_field_i_internal_name_db_processed = (s_field_i_internal_name_db!=null)? s_field_i_internal_name_db : "";
                    
					let s_field_i_value_html = '<div \
						id="' + s_div_value_holder_key + '"\
						k_ds="' + s_schema_internal_name + '"\
						k_col="' + s_table_internal_name + '"\
						k_field="' + s_field_i_internal_name + '"\
                        k_field_db="' + s_field_i_internal_name_db_processed + '"\
						k_field_ext="' + s_field_i_external_name + '"\
					></div>';
					
					let s_row_id = "obj_details_table_write_row__" + s_field_i_internal_name;
					
					let a_row_values = [s_field_i_external_name, s_field_i_value_html];
					table_data.addRows([a_row_values], [s_row_id]);
				}
				
			
			
			}
			
			let table = private_objs.o_table;
			table.addRows(table_data);
			
			this.f_create_col_value_content();
            
		},
		
		f_create_col_value_content: function()
		{
			var private_objs = this.private_objs;
			var a_column_value_holder_div = private_objs.a_column_value_holder_div;
			var o_details = NSObjDetailsEditPrivate.private_objs.o_details;
			var o_details_edit = NSObjDetailsEditPrivate.private_objs.o_details_edit;
			
			var o_table = private_objs.o_table;
			
			private_objs.a_field_edit_struct = new Array();
			
			var o_geometry = this.o_geometry;
			
			
			var a_ = a_column_value_holder_div;
			for(var i=0; i<a_.length; i++)
			{
				var s_key_i = a_[i];
				
				var e_div_i = document.getElementById(s_key_i);
				
				var s_schema_internal_name = e_div_i.getAttribute("k_ds");
				var s_table_internal_name = e_div_i.getAttribute("k_col");
				var s_field_i_internal_name = e_div_i.getAttribute("k_field");
                var s_field_i_internal_name_db = e_div_i.getAttribute("k_field_db");
				var s_field_i_external_name = e_div_i.getAttribute("k_field_ext");
				
				var e_tr_i = e_div_i.parentElement.parentElement;
				
				let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_i_internal_name);	
//				var o_field_schema_info = NSSchemaInfo.f_get_field_schema_info(s_schema_internal_name, s_table_internal_name, s_field_i_internal_name);
				
				var b_field_is_mandatory = o_field_info_i.mandatory;
				if(b_field_is_mandatory)
				{
					var sClassesList = e_tr_i.getAttribute("class");
					var sClass = "required";
					sClassesList = NSFunctions.elemCSSClass_addClass(sClassesList, sClass);
					e_tr_i.setAttribute("class", sClassesList);
				}
				
				
				let o_GeometryEditControl = null;
				let o_ParentJoinEditControl = null; //{NSObjDetailsEditPrivate.objs.ParentJoinEditControl}
				var e_value_control;
				if(o_field_info_i.is_join)
				{
					let b_field_is_child = o_field_info_i.is_target
					let b_field_is_parent = o_field_info_i.is_fk;
					let b_creating_child_mode_and_field_is_parent = this.f_boolean__creating_child_mode_and_field_is_parent(o_field_info_i);
					var b_urn_is_for_creation = NSObjDetailsEditPrivate.f_editor_is_in_creation_mode();

					//get value
					/*
					let s_value = o_details_edit.f_get_original_field_value("arvore_intervencao")
					s_value = (s_value!=null)? s_value : '';
					*/
					let s_internal_name_db = (b_field_is_child) ? s_field_i_internal_name_db : s_field_i_internal_name;
					let o_field_join_info = o_details.f_join_field_info_by_internal_name_db_and_external_col_urn(
						s_internal_name_db, 
						o_field_info_i.external_col_urn);
					let join_count = (o_field_join_info != null)? o_field_join_info.join_count: null;
					let s_value = (join_count!=null)? join_count : '';
						
					//creating element
					let e_ = document.createElement("div");
					let e_span = document.createElement("span");
					e_span.innerHTML = s_value + ' ';
					e_.appendChild(e_span);

					//if(b_creating_child_mode_and_field_is_parent)
					//if(b_urn_is_for_creation)
					if(
						b_creating_child_mode_and_field_is_parent
						|| ( b_urn_is_for_creation && b_field_is_child )
					)
					{
						// no edition is allowed, the update will be automatic

						//if object is in creation mode enter here so other joins to parents and childs cannot be edited?
						//	-> use b_creating_child_mode_and_field_is_parent in stead of b_urn_is_for_creation?
						//	-> parent join from which the creation was activated should not be editable
						//  -> join childs should not be available in creation mode


					}
					else if(b_field_is_child) // join to childs
					{
						var s_urn_parent_of_future_child = NSObjDetailsEditPrivate.f_get_urn_of_obj_in_edition();

						let s_external_table_urn = NSURN.f_create_table_urn_from_column_urn(o_field_info_i.external_col_urn); //o_field_info_i.external_col_urn -> column urn

						/*
							returns button create joing child, document element if user has permissions
							
							o_in:
							{
								s_table_urn,		//	table urn on the child object to be created
								s_urn_parent		//  urn of parent object
							}
						*/
						var o_in = 
						{
							s_table_urn: s_external_table_urn,
							s_urn_parent: s_urn_parent_of_future_child
						}
						
						let b_assume_inherits_geometry = ( NSDataModelInfo.f_get_table_first_geometry_field_info_by_urn(s_external_table_urn) == null
															&& o_details.feature.geometry != null)? true : false;
						if(b_assume_inherits_geometry)
						{
							o_in.b_geometry_is_inherited  = true;
							o_in.o_parent_geometry = o_details.feature.geometry;
						}

						var e_button_create_child = NSObjDetailsCreate.f_get_button_create_join_child_HTML_elem(o_in);
						
						if(e_button_create_child != null)
						{
							e_.appendChild(e_button_create_child);
						}

					}
					else if(b_field_is_parent) // If is parent, then we should allow switching parent
					{
						let s_join_table_internal_name = s_field_i_internal_name; //internal name of field pointing to parent
						let s_external_table_urn = NSURN.f_create_table_urn_from_column_urn(o_field_info_i.external_col_urn); //o_field_info_i.external_col_urn -> column urn
						
						var o_in = {
							s_external_table_urn: s_external_table_urn,
							s_field_internal_name : s_field_i_internal_name,
							s_field_i_internal_name_db : s_field_i_internal_name_db
						};
						
						var e_button_switch_parent =  this.f_get_button_switch_join_parent_HTML_elem(o_in);
						
						if(e_button_switch_parent != null){
							e_.appendChild(e_button_switch_parent);
						}

						/*
							o_in
							{
								e_div: e_div,
								e_button_switch_parent: e_button_switch_parent
							}
						*/
						o_ParentJoinEditControl = new NSObjDetailsEditPrivate.objs.ParentJoinEditControl({e_div: e_, e_button_switch_parent: e_button_switch_parent}); 
						
					}

					e_value_control = e_;
					e_div_i.appendChild(e_value_control);

					
				}
				else if ( NSDataTypes.f_type_is_geometry(o_field_info_i.data_type) )
				{
					
					/*
					o_in
					{
						s_schema_internal_name,
						s_table_internal_name,
						s_field_internal_name
					}
					
					result {NSObjDetailsEditPrivate.objs.GeometryEditControl} :
					{
						e_div_geom,
						e_button_edit,
						e_button_ok,
						e_button_cancel
					}
					*/
					var o_in = {
						s_schema_internal_name: s_schema_internal_name,
						s_table_internal_name: s_table_internal_name,
						s_field_internal_name: s_field_i_internal_name
					};
					o_GeometryEditControl = o_geometry.f_create_edit_geometry_control(o_in); //{NSObjDetailsEditPrivate.objs.GeometryEditControl}
					
					e_value_control = o_GeometryEditControl.e_div_geom;
					e_div_i.appendChild(e_value_control);
					
				}
				else if (o_field_info_i.is_enum)
				{
					var s_value = o_details_edit.f_get_original_field_value(s_field_i_internal_name);
					s_value = (s_value!=null)? s_value : '';
					
					var a_catalogue_entries = o_field_info_i.a_enumerator_values;
					var a_cmp_desc = a_catalogue_entries;
					var a_cmp_key = a_cmp_desc;
					//<select id="' + s_id_sel_field + '" class="form-control form-control-sm"></select> 
					var s_id = NSFunctions.guidGenerator();
					var e_ = document.createElement("select");
					e_.setAttribute("id", s_id);
					e_.classList.add("form-select", "form-select-sm");
					e_value_control = e_;
					
					e_div_i.appendChild(e_value_control);
					
					var f_onSelect_ = function(s_key)
					{
						//this_.f_onSelect_(s_key);
					}
					var o_combo_ =  new NSCombos.objs.Combo(s_id, f_onSelect_, [], null);
					o_combo_.reset(a_cmp_desc, a_cmp_key, true);
					var s_desc = s_value;
					o_combo_.setSelected_by_desc(s_desc)
					
				}
				else if( NSDataTypes.f_type_is_any_number_type(o_field_info_i.data_type) )
				{
					var s_value = o_details_edit.f_get_original_field_value(s_field_i_internal_name);
					
					//Round to decimal places in config.json
					var i_dp = NSObjDetailsEditPrivate.private_objs.settings.decimal_places;	
					s_value = NSFunctions.roundNumber(  s_value , i_dp);
					
					s_value = (s_value!=null)? s_value : '';
					
					var e_ = document.createElement("input");
					e_.setAttribute("type", "number");
					e_.classList.add("form-control", "form-control-sm");
					
					var s_number_type;
					if( NSDataTypes.f_type_is_integer_number(o_field_info_i.data_type) )
					{
						var s_step = "1";
						e_.setAttribute("step", s_step);
						s_number_type="Número Inteiro";
					}
					else
					{
						var s_step = "0.000000001";
						e_.setAttribute("step", s_step);
						s_number_type="Número";
					}

					var b_type_number_is_supported = NSFunctions.f_check_input_type_number_support();
					
					e_.setAttribute("placeholder", s_number_type);
					e_.value = s_value;
					
					e_value_control = e_;
					
					e_div_i.appendChild(e_value_control);
					
				}
				else if( NSDataTypes.f_type_is_date(o_field_info_i.data_type) )
				{
					var s_value = o_details_edit.f_get_original_field_value(s_field_i_internal_name);
					var e_ = NSDateDatetime.NSDate.f_create_elem_date();
					e_.classList.add("form-control", "form-control-sm");
					//s_value -> "2010-04-08Z"
					NSDateDatetime.NSDate.f_set_elem_value_from_db_date_string(e_, s_value);
					
					e_value_control = e_;
					
					e_div_i.appendChild(e_value_control);
				}
				else if(  NSDataTypes.f_type_is_datetime(o_field_info_i.data_type) )
				{
					var s_value = o_details_edit.f_get_original_field_value(s_field_i_internal_name);
					var e_ = NSDateDatetime.NSDate.f_create_elem_date();
					e_.classList.add("form-control", "form-control-sm");
					//s_value -> "2010-04-08Z"
					NSDateDatetime.NSDate.f_set_elem_value_from_db_date_string(e_, s_value);
					
					e_value_control = e_;
					
					e_div_i.appendChild(e_value_control);
				}
				else
				{
					var s_value = o_details_edit.f_get_original_field_value(s_field_i_internal_name);
					s_value = (s_value!=null)? s_value : '';

					var e_ = document.createElement("input");
					
					e_.setAttribute("type", "text");
					e_.setAttribute("placeholder", "");
					e_.classList.add("form-control", "form-control-sm");
					e_.value = s_value;
					
					e_value_control = e_;
					
					e_div_i.appendChild(e_value_control);
				
					
				}
				
				var s_row_id = "obj_details_table_write_row__" + s_field_i_internal_name;
				//var e_tr = document.getElementById(s_row_id);
				var e_tr = o_table.f_get_tr_by_row_key(s_row_id);
				
				
				var o_in =
				{
					s_schema_internal_name: s_schema_internal_name,
					s_table_internal_name: s_table_internal_name,
					s_field_internal_name: s_field_i_internal_name,
                    s_field_i_internal_name_db: s_field_i_internal_name_db,
					s_field_external_name: s_field_i_external_name,		// field external name
					e_edit_element: e_value_control,
					e_tr: e_tr,											//	table row element (tr)
					o_GeometryEditControl: o_GeometryEditControl,		//	not null if field is of type geometry
					o_ParentJoinEditControl: o_ParentJoinEditControl	//	not null if field is of type parent join - {NSObjDetailsEditPrivate.objs.ParentJoinEditControl}
					
					
				}
				var o_field_edit_struct = new NSObjDetailsEditPrivate.objs.FieldEdit(o_in);
				private_objs.a_field_edit_struct.push(o_field_edit_struct);
				
				this.f_add_onchange_function_to_e_value_control_(e_value_control, o_field_edit_struct);
				
				
			}
			
			
		},
		
		/*
		o_in:
		{
			s_external_table_urn,
			s_field_internal_name,
			s_field_i_internal_name_db
		}
		*/
		f_get_button_switch_join_parent_HTML_elem: function(o_in)
		{
			let this_ = this;
			let s_external_table_urn = o_in.s_external_table_urn;
			let s_field_internal_name = o_in.s_field_internal_name;
			let s_field_i_internal_name_db = o_in.s_field_i_internal_name_db;
			

			let b_user_has_permissions = NSUserFunctionPermissions.f_has_permission_for_function_type_UPDATE_and_collection_urn(s_external_table_urn);
			
			var e_button;
			if(b_user_has_permissions)
			{
				e_button = document.createElement("button");
				e_button.setAttribute("type", "button");
				e_button.setAttribute("class", "btn btn-sm btn-outline-secondary ");
				e_button.setAttribute("id", "button_switch_parent");
				e_button.innerHTML = '<img src="' + xCore.application.images_base_path + '/common/arrow-up.svg" alt="" width="16" height="16">'
				
				e_button.onclick = function(event)
				{
					let f_cb = function(s_urn_parent)
					{
						this_.f_switch_parent_validation_confirmation(s_urn_parent, s_external_table_urn, s_field_internal_name, s_field_i_internal_name_db, e_button);
					};

					if( !Module_Map.state.f_get_switch_parent_is_active() )
					{
						let s_label_obj_details_edit_parent_switch_error_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_parent_switch_error_message");
						NSMessages.f_show_information( s_label_obj_details_edit_parent_switch_error_message , 5000 );
						Module_Map.state.f_set_switch_parent(true, f_cb);

					}
					else
					{
						Module_Map.state.f_set_switch_parent(false);
					}
				};				
			}
			
			
			return e_button;
			
		},
				
		f_switch_parent_validation_confirmation : function( s_urn_parent_in, s_external_table_urn, s_field_internal_name, s_field_i_internal_name_db, e_button_control_of_switchparent ){


			var child_urn = NSObjDetailsEditPrivate.f_get_urn_of_obj_in_edition();	
			var a_feature_urn_info = NSURN.f_get_urn_info(child_urn);
			var s_schema_internal_name = a_feature_urn_info[1];
			var s_table_internal_name = a_feature_urn_info[2];

			let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);	
			let s_table_urn_parent_in = NSURN.f_create_table_urn_from_record_urn(s_urn_parent_in);

			//let s_external_table_urn = NSURN.f_create_table_urn_from_column_urn(o_field_info_i.external_col_urn); //o_field_info_i.external_col_urn -> column urn

			//Validate if both urns correspond to child/parent relationship
			let isParent = (s_table_urn_parent_in == s_external_table_urn)
			if (isParent ) 
			{
				let s_msg = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_parent_switch_confirm_message");

				let f_cb_ok = function()
				{
					let s_parent_record_id = NSURN.f_get_urn_record_id(s_urn_parent_in);
					let o_details_edit = NSObjDetailsEditPrivate.private_objs.o_details_edit;
					o_details_edit.f_set_edit_field_value(s_field_i_internal_name_db, s_parent_record_id); // for this structure field_internal_name_db must be used!
					Module_Map.state.f_set_switch_parent(false);
					if(e_button_control_of_switchparent.onchange != null) // adding onchange support to listners
					{
						e_button_control_of_switchparent.onchange();
					}
					let s_label_obj_details_edit_parent_switch_success_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_parent_switch_success_message");
					NSMessages.f_show_success( s_label_obj_details_edit_parent_switch_success_message , 5000);
				};

				let f_cb_cancel = function()
				{
					Module_Map.state.f_set_switch_parent(false);
				};

				let s_label_obj_details_edit_parent_switch_confirm_title = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_parent_switch_confirm_title");
				let s_label_common_confirm = NSPageLabels.f_get_label_text_by_internal_name("common_confirm");
				let s_label_common_cancel = NSPageLabels.f_get_label_text_by_internal_name("common_cancel");
				
				NSConfirm.f_show({
					s_title_text: s_label_obj_details_edit_parent_switch_confirm_title,
							s_button_ok_text: s_label_common_confirm,
							s_button_cancel_text: s_label_common_cancel,
							s_text: s_msg,
							f_on_ok_cb: f_cb_ok,
							f_on_cancel_cb: f_cb_cancel
					});

			}
			else
			{
				let s_label_obj_details_edit_parent_switch_error_message_invalid_obj = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_parent_switch_error_message_invalid_obj");
				NSMessages.f_show_error( s_label_obj_details_edit_parent_switch_error_message_invalid_obj + " "  , 5000);
				Module_Map.state.f_set_switch_parent(false);
			}
			
		},
		
		f_add_onchange_function_to_e_value_control_: function (e_value_control, o_field_edit_struct)
		{
			
			var s_schema_internal_name = o_field_edit_struct.s_schema_internal_name;
			var s_table_internal_name = o_field_edit_struct.s_table_internal_name;
			var s_field_internal_name = o_field_edit_struct.s_field_internal_name;
			
            let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);		
//			var o_field_schema_info = NSSchemaInfo.f_get_field_schema_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
			
			var f_get_onchange_cb_function = function (o_field_edit_struct_in, f_old_in)
				{
					return function ()
					{
						o_field_edit_struct_in.b_changed = true;
						
						if(f_old_in != null)
						{
							f_old_in();
						}
					}
					
				}
			
			
            if(o_field_info_i.is_join) 
			{
				let b_field_is_parent = o_field_info_i.is_fk;
				let b_creating_child_mode_and_field_is_parent = this.f_boolean__creating_child_mode_and_field_is_parent(o_field_info_i);
				if(b_creating_child_mode_and_field_is_parent)
				{
					// no edition is allowed, the update will be automatic
					o_field_edit_struct.b_changed = true;
					
				}
				else if(b_field_is_parent)
				{
					let o_ParentJoinEditControl = o_field_edit_struct.o_ParentJoinEditControl; // {NSObjDetailsEditPrivate.objs.ParentJoinEditControl}
					let e_button_switch_parent = o_ParentJoinEditControl.e_button_switch_parent;

					if(e_button_switch_parent)
					{
						let f_onchange_old = null;
						if(e_button_switch_parent.onchange != null)
						{
							f_onchange_old = e_button_switch_parent.onchange;
						}
						//onchange support has been added to parent switch button / control
						e_button_switch_parent.onchange = f_get_onchange_cb_function(o_field_edit_struct, f_onchange_old);
					}
				}
			}
			else if( NSDataTypes.f_type_is_geometry(o_field_info_i.data_type) )
			{
				let o_GeometryEditControl = o_field_edit_struct.o_GeometryEditControl;
				let e_button_ok = o_GeometryEditControl.e_button_ok;
				
				let f_onclick_old = null;
				if(e_button_ok.onclick != null)
				{
					f_onclick_old = e_button_ok.onclick;
				}
				e_button_ok.onclick = f_get_onchange_cb_function(o_field_edit_struct, f_onclick_old);
			}
			else
			{
				
				
				let f_onchange_old = null;
				if(e_value_control.onchange != null)
				{
					f_onchange_old = e_value_control.onchange;
				}
				//onchange is, at least, suported by the tags select, input (various types), textarea and keygen
				e_value_control.onchange = f_get_onchange_cb_function(o_field_edit_struct, f_onchange_old);
			}
			
			
		},
		
		
		// returns true if all input is valid, and updates internal data structure
		f_validate_and_update_internal_data_structure: function()
		{
			let private_objs = this.private_objs;
			let o_validate = NSObjDetailsEditPrivate.o_validate;

			
			let b_all_input_is_valid =  true;
			let s_error_message = "";
			let s_error_message_mandatory_part = "<br>O campo é obrigatório!"
			
			let a_field_edit_struct = private_objs.a_field_edit_struct; //[{NSObjDetailsEditPrivate.objs.FieldEdit}]
			
			let o_details_edit = NSObjDetailsEditPrivate.private_objs.o_details_edit; // {NSObjDetailsEditPrivate.objs.ObjInfo}
			
			this.f_clean_table_invalid_field_style();
			
			
			for(let i=0; i<a_field_edit_struct.length; i++)
			{
				let o_field_edit_struct_i = a_field_edit_struct[i];
					
				let s_schema_internal_name = o_field_edit_struct_i.s_schema_internal_name;
				let s_table_internal_name = o_field_edit_struct_i.s_table_internal_name;
				let s_field_internal_name = o_field_edit_struct_i.s_field_internal_name;
				let s_field_external_name = o_field_edit_struct_i.s_field_external_name;
				let e_edit_element = o_field_edit_struct_i.e_edit_element;
				let e_tr = o_field_edit_struct_i.e_tr;
				
                let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
				let b_field_is_mandatory = o_field_info_i.mandatory
				let b_field_is_empty;
				let b_field_is_valid = true;
				
				//var s_original_value = o_details_edit.f_get_original_field_value(s_field_i_external_name);
				//var s_value = o_details_edit.f_get_original_field_value(s_field_i_external_name);
				
				
                if(o_field_info_i.is_join)
				{
					/*
						o_field_schema_info -> field must be of join type, parent table internal name will be the internal_name
					*/
					let b_creating_child_mode_and_field_is_parent = this.f_boolean__creating_child_mode_and_field_is_parent(o_field_info_i);
					if(b_creating_child_mode_and_field_is_parent)
					{
						let s_parent_record_urn = NSObjDetailsEditPrivate.private_objs.s_urn_parent;
						let s_parent_record_id = NSURN.f_get_urn_record_id(s_parent_record_urn);
						let s_new_value = s_parent_record_id; // parent_record_urn
						let s_field_i_internal_name_db = o_field_info_i.internal_name_db;
						o_details_edit.f_set_edit_field_value(s_field_i_internal_name_db, s_new_value);
					}
					
				}
				else if (o_field_info_i.is_enum)
				{
					let s_new_value = e_edit_element.value;
					

					b_field_is_empty = ( e_edit_element.selectedIndex == -1 )? true : false;
					if(e_edit_element.selectedIndex > -1) // combobox might have an empty value at position 0
					{
						//b_field_is_empty = ( o_field_info_i.a_enumerator_values.indexOf(s_new_value) == -1 )? true : false; // means the empty value at the combo is not an valid enum member
						b_field_is_empty = ( s_new_value == null || (s_new_value.trim().length == 0) )? true : false;
					}

					if(b_field_is_mandatory && b_field_is_empty)
					{
						b_field_is_valid = false;
					}
					
					if(b_field_is_valid)
					{
						o_details_edit.f_set_edit_field_value(s_field_internal_name, s_new_value);	
					}
					
					
				}				
				else if ( NSDataTypes.f_type_is_geometry(o_field_info_i.data_type) )
				{

					//geometries are validated and saved when accept button is clicked
					let o_edited_field_value = o_details_edit.f_get_edit_field_value(s_field_internal_name);
					let o_geojson_feature_geometry = o_edited_field_value;
					let b_gj_geom_has_content = NSGeoJson.f_geojson_geometry_has_content(o_geojson_feature_geometry);
					b_field_is_empty = !b_gj_geom_has_content;
					if(b_field_is_mandatory && b_field_is_empty)
					{
						b_field_is_valid = false;
					}
					
				}
				else if ( NSDataTypes.f_type_is_integer_number(o_field_info_i.data_type) )
				{
					let s_new_value = e_edit_element.value;
					//let b_field_is_valid;
					if(s_new_value == null || s_new_value == "")
					{
						b_field_is_valid = true;
					}
					else
					{
						let b_is_int = o_validate.f_s_is_int(s_new_value);
						//var b_field_is_valid = b_is_int;
						b_field_is_valid = b_is_int;
					}
					
					b_field_is_empty = (s_new_value == null || s_new_value == "")? true : false;
					
					if(b_field_is_mandatory && b_field_is_empty)
					{
						b_field_is_valid = false;
					}
					
					
					if(b_field_is_valid)
					{
						o_details_edit.f_set_edit_field_value(s_field_internal_name, s_new_value);
					}
					
				}
				else if ( NSDataTypes.f_type_is_date_or_datetime(o_field_info_i.data_type) )
				{
					//var s_new_value = e_edit_element.value;
					let s_new_value;
					
					//var b_field_is_valid;
					
					let s_date_untreated = NSDateDatetime.NSDate.f_get_value(e_edit_element);
					b_field_is_empty = (s_date_untreated == null || s_date_untreated == "")? true : false;
					if(b_field_is_empty && !b_field_is_mandatory)
					{
						b_field_is_valid = true;
						
						s_new_value = "";
					}
					else if(b_field_is_empty && b_field_is_mandatory)
					{
						b_field_is_valid = false;
					}
					else
					{
						b_field_is_valid = NSDateDatetime.NSDate.f_date_is_valid(e_edit_element);
					}
					
					if(b_field_is_valid)
					{
						//date is valid
                        let s_new_value = NSDateDatetime.NSDate.f_get_value_as_db_date_string(e_edit_element);
						o_details_edit.f_set_edit_field_value(s_field_internal_name, s_new_value);
					}
					
					
				}
				else
				{
					let s_new_value = e_edit_element.value;
					
					
					b_field_is_empty = (s_new_value == null || s_new_value == "")? true : false;
					
					if(b_field_is_mandatory && b_field_is_empty)
					{
						b_field_is_valid = false;
					}
					
					if(b_field_is_valid)
					{
						o_details_edit.f_set_edit_field_value(s_field_internal_name, s_new_value);
					}
					
					
				}
				

				//for all types:
				if(!b_field_is_valid)
				{
					let s_classes = e_tr.getAttribute("class");
					let s_class = "invalid_field";
					let s_classes_new = NSFunctions.elemClass_addClass(s_classes, s_class);
					e_tr.setAttribute("class", s_classes_new);
					if(b_all_input_is_valid)
					{
						s_error_message = "Campo inválido: " + s_field_external_name;
						if(b_field_is_mandatory && b_field_is_empty)
						{
							s_error_message += s_error_message_mandatory_part;
						}
					}
					b_all_input_is_valid = false;
				}
				
				
			}
			
			
			
			if(!b_all_input_is_valid )
			{
				NSMessages.f_show_information(s_error_message);
			}
			
			return b_all_input_is_valid;
			

		},
		f_clean_table_invalid_field_style: function()
		{
			var private_objs = this.private_objs;
			
			var a_field_edit_struct = private_objs.a_field_edit_struct; //[{NSObjDetailsEditPrivate.objs.FieldEdit}]
			for(var i=0; i<a_field_edit_struct.length; i++)
			{
				var o_field_edit_struct_i = a_field_edit_struct[i];
				/*
				var s_schema_internal_name = o_field_edit_struct_i.s_schema_internal_name;
				var s_table_internal_name = o_field_edit_struct_i.s_table_internal_name;
				var s_field_internal_name = o_field_edit_struct_i.s_field_internal_name;
				var s_field_external_name = o_field_edit_struct_i.s_field_external_name;
				var e_edit_element = o_field_edit_struct_i.e_edit_element;
				*/
				var sClass = "invalid_field";
				
				var e_tr = o_field_edit_struct_i.e_tr;
				var sClassesList = e_tr.getAttribute("class");
				var sClassesList_new = NSFunctions.elemClass_RemoveClass(sClassesList, sClass);
				e_tr.setAttribute("class", sClassesList_new);

				
			}
		},
		
		f_execute_save: function()
		{
			var this_ = this;
			
			var o_edit_elements_state_functions = NSObjDetailsEditPrivate.o_edit_elements_state_functions;
		
			var b_button_active = o_edit_elements_state_functions.f_button_save_is_enabled();
			
			if (!b_button_active)
			{
				return;
			}
			
			var b_urn_is_for_creation = NSObjDetailsEditPrivate.f_editor_is_in_creation_mode();
			
			o_edit_elements_state_functions.f_button_save_disable();
			if(!b_urn_is_for_creation)
			{
				o_edit_elements_state_functions.f_button_delete_disable();	
			}
			o_edit_elements_state_functions.f_button_cancel_disable();
			
			
			var b_all_input_is_valid = this.f_validate_and_update_internal_data_structure();
			
			if(b_all_input_is_valid)
			{
				o_edit_elements_state_functions.f_show_save_loading();
				this.f_execute_save_part_2();
			}
			else
			{
				o_edit_elements_state_functions.f_button_save_enable();
				if(!b_urn_is_for_creation)
				{
					o_edit_elements_state_functions.f_button_delete_enable();	
				}
				o_edit_elements_state_functions.f_button_cancel_enable();

			}
			
			
		},
		f_execute_save_part_2: function()
		{
			var private_objs = this.private_objs;			
		
			var a_field_edit_struct = private_objs.a_field_edit_struct; //[{NSObjDetailsEditPrivate.objs.FieldEdit}]
			
			var o_details_edit = NSObjDetailsEditPrivate.private_objs.o_details_edit; // {NSObjDetailsEditPrivate.objs.ObjInfo}
			
			var s_obj_urn = o_details_edit.s_urn;
			
			
			this.f_call_update();
				
				
			
		},
		
		f_call_update: function ()
		{
			let this_ = this;
		
			let private_objs = this.private_objs;
			
		
			let a_field_edit_struct = private_objs.a_field_edit_struct; //[{NSObjDetailsEditPrivate.objs.FieldEdit}]
			
			let o_details = NSObjDetailsEditPrivate.private_objs.o_details;
			let o_details_edit = NSObjDetailsEditPrivate.private_objs.o_details_edit; // {NSObjDetailsEditPrivate.objs.ObjInfo}
			
			let s_obj_urn = o_details_edit.s_urn;

//			let s_proposed_values = "";
            let a_input_params = [];
			
			/*
				ex: a_bounds_list: [
						{"x_min": -1049177.4708982694, "y_min": 4678073.1988951415, "x_max": -1048030.9154739918, "y_max": 4678538.389871972}
					]
			*/
			let a_bounds_list = [];
			
//			let s_comma = ",";

			let b_geometry_changes_implies_tiles_update = true; //Overlays.f_get_tree_node_is_of_tile_type(o_details.tree_node_id);

			for(let i=0; i<a_field_edit_struct.length; i++)
			{
				let o_field_edit_struct_i = a_field_edit_struct[i];
					
				let s_schema_internal_name = o_field_edit_struct_i.s_schema_internal_name;
				let s_table_internal_name = o_field_edit_struct_i.s_table_internal_name;
				let s_field_internal_name = o_field_edit_struct_i.s_field_internal_name;
				let s_field_i_internal_name_db = o_field_edit_struct_i.s_field_i_internal_name_db;				
				let s_field_external_name = o_field_edit_struct_i.s_field_external_name;
				let e_edit_element = o_field_edit_struct_i.e_edit_element;
				let e_tr = o_field_edit_struct_i.e_tr;

				/*
				if(s_field_i_internal_name_db == null || s_field_i_internal_name_db != "")
				{
					s_field_i_internal_name_db = s_field_internal_name
				}
				*/

				
				let b_changed = o_field_edit_struct_i.b_changed;
				if(b_changed)
				{
                    let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);		
//					let o_field_schema_info = NSSchemaInfo.f_get_field_schema_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
				
				
					//let s_original_value = o_details_edit.f_get_original_field_value(s_field_i_external_name);
					//let s_value = o_details_edit.f_get_original_field_value(s_field_i_external_name);
					let o_edited_field_value = o_details_edit.f_get_edit_field_value(s_field_internal_name);
					let s_edited_field_value;
					
					
					if(o_field_info_i.is_join)
					{
						s_field_internal_name = s_field_i_internal_name_db;
						o_edited_field_value = o_details_edit.f_get_edit_field_value(s_field_i_internal_name_db);
						s_edited_field_value = o_edited_field_value;
					}
					else if (NSDataTypes.f_type_is_geometry(o_field_info_i.data_type))
					{

                        let o_geojson_feature_geometry = o_edited_field_value;
                        s_edited_field_value = (o_geojson_feature_geometry!=null)? JSON.stringify(o_geojson_feature_geometry) : null;


						if(b_geometry_changes_implies_tiles_update)
						{
							let o_original_geojson_feature_geometry = o_details_edit.f_get_original_field_value(s_field_internal_name);

							let a_bounds = NSGeoJson.f_get_bounds_from_geojson_geometry(o_original_geojson_feature_geometry);
							if(a_bounds!=null)
							{
								a_bounds_list.push({"x_min": a_bounds[0], "y_min": a_bounds[1], "x_max": a_bounds[2], "y_max": a_bounds[3]});
							}

							a_bounds = NSGeoJson.f_get_bounds_from_geojson_geometry(o_geojson_feature_geometry);
							if(a_bounds!=null)
							{
								a_bounds_list.push({"x_min": a_bounds[0], "y_min": a_bounds[1], "x_max": a_bounds[2], "y_max": a_bounds[3]});
							}
						}
						
						
						
					}
					else if(NSDataTypes.f_type_is_date(o_field_info_i.data_type))
					{

                        s_edited_field_value = NSDateDatetime.NSDate.f_convert_from__db_format__to__update_format(o_edited_field_value);
                        
					}
					else if(NSDataTypes.f_type_is_datetime(o_field_info_i.data_type))
					{
						
						
					}
					else
					{
						
						s_edited_field_value = o_edited_field_value;
						
					}
					
					if( s_edited_field_value === "") {
							//s_edited_field_value = "__NULL__";
                            s_edited_field_value = null;
					}
					
//					s_proposed_values += s_comma + s_field_internal_name + ":" + s_edited_field_value;
                    a_input_params.push(
                        {
                            "name": s_field_internal_name, "value": s_edited_field_value
                        }
                    );
				}
			}
			
			if(a_input_params.length == 0)
			{
				let s_error_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_save_error_nochanges_message");
				NSMessages.f_show_information(s_error_message);
				NSObjDetailsEditPrivate.o_edit_elements_state_functions.f_set_initial_state();
				return;
			}
			

			let s_table_urn = NSURN.f_create_table_urn_from_record_urn(s_obj_urn);
			

			//adding extra input

			
            let f_cb = function (o_resp)
			{
				this_.f_call_update_process_result_(o_resp);
			}
			
            
            let a_feature_urn_info = NSURN.f_get_urn_info(s_obj_urn);
            let s_schema_internal_name = a_feature_urn_info[1];
            let s_table_internal_name = a_feature_urn_info[2];
            let s_record_key = ( a_feature_urn_info.length > 3)? a_feature_urn_info[3] : null;

			let b_urn_is_for_creation = NSObjDetailsEditPrivate.f_editor_is_in_creation_mode();
			if(b_urn_is_for_creation) //insert
			{
                
                //adding new element to head of the array
                a_input_params.unshift({"name": "id", "value": null});

                let o_insert_in =
                {
                    "table_urn": s_table_urn,
                    "input_params": a_input_params                    
                };
				
				if (NSObjDetailsCloneData.f_is_eligible(o_insert_in.table_urn) && $('#button_obj_details_edit_copy').hasClass('active')) {
					const aMessage = "Esta inserção foi guardada. Pode agora copiá-la para outros objectos do mesmo tipo!"
					NSMessages.f_show_information(aMessage, 5000);
					NSObjDetailsCloneData.f_store_data(o_insert_in);
				}

				NSServerCalls.f_edit_obj_upsert(o_insert_in, f_cb);
			}
			else //update
			{

                //adding new element to head of the array
                a_input_params.unshift({"name": "id", "value": s_record_key});

                let o_update_in =
                {
                    "table_urn": s_table_urn,
                    "input_params": a_input_params                    
                };
				

				if (NSObjDetailsCloneData.f_is_eligible(o_update_in.table_urn) && $('#button_obj_details_edit_copy').hasClass('active')) {
					const aMessage = "Esta inserção foi guardada. Pode agora copiá-la para outros objectos do mesmo tipo!"
					NSMessages.f_show_information(aMessage, 5000);
					NSObjDetailsCloneData.f_store_data(o_update_in);
					console.log(JSON.stringify(o_update_in));
				}

				NSServerCalls.f_edit_obj_upsert(o_update_in, f_cb);
			}
		},
		
		f_call_update_process_result_: function (o_resp)
		{
            
            
			if( o_resp != null && o_resp.success ==true )
			{
                //NSPageHeaderToolbar.f_o_dd_draw_clear_onclick();
                NSToolDraw.f_disable();
				
				var o_details = NSObjDetailsEditPrivate.private_objs.o_details;
				var o_details_edit = NSObjDetailsEditPrivate.private_objs.o_details_edit;

				let s_table_urn = NSURN.f_create_table_urn_from_record_urn(o_details.s_urn)
				//Overlays.f_refresh_layer_by_tree_node_id(o_details.tree_node_id);
				Overlays.f_refresh_layers_by_table_urn(s_table_urn);
				NSResultsInterface.f_clean_results_interface();

                let s_obj_urn = o_details_edit.s_urn;
                let s_record_urn;
                let b_urn_is_for_creation = NSObjDetailsEditPrivate.f_editor_is_in_creation_mode();//NSObjDetailsCreate.f_urn_is_for_creation(s_obj_urn);
                if(b_urn_is_for_creation) //insert
                {
					let s_record_id = o_resp.output_params[0].value;
                    s_record_urn = NSURN.f_create_record_urn_from_table_urn(s_table_urn , s_record_id);

                }
                else
                {
                    s_record_urn =  s_obj_urn;
                }
				
                let s_geometry_internal_name = NSObjDetailsEditPrivate_.private_objs.o_details.geometry_name;
                let b_is_icon = NSObjDetailsEditPrivate_.private_objs.o_details.b_is_icon;
                let a_icon_size_xy = NSObjDetailsEditPrivate_.private_objs.o_details.a_icon_size_xy;
                let b_clean_join_list = true;

				/*
                //NSObjDetails.f_open_details(o_details, b_clean_join_list, b_clean_o_geo_json_highlight_geom);
					-> wouldn't work because some data is dynamically update on server side (actualizado_por; freguesia...)
					-> NSObjDetails.f_open_details_by_urn(o_in); will force a server call

				*/
                /*
                    o_in:
                    {
						tree_node_id,
                        s_urn, 
                        b_clean_join_list,
                        o_ll,						// (optional) - {google.maps.LatLng}
                        o_geo_json					// (optional) - {GeoJson}
                        s_geometry_internal_name	// internal name of the geometry field
                        b_is_icon,
                        a_icon_size_xy	//[width, height]
                    }
                */
                let o_in = {
					tree_node_id: o_details.tree_node_id,
                    s_urn: s_record_urn,
                    b_clean_join_list: b_clean_join_list,
                    s_geometry_internal_name: s_geometry_internal_name,
                    b_is_icon: b_is_icon,
                    a_icon_size_xy: a_icon_size_xy
                }
                NSObjDetails.f_open_details_by_urn(o_in);
                

            }
			else{
				var s_error_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_save_error");
				
				if(o_resp != null && o_resp.error != null && o_resp.error != "")
				{
					s_error_message += ":<br><br>" + o_resp.error;
				}
				else
				{
					s_error_message += ".";
				}
				NSMessages.f_show_information(s_error_message);
				NSObjDetailsEditPrivate.o_edit_elements_state_functions.f_set_initial_state();
				
				
			}
			
		},
		
		f_execute_cancel: function()
		{			
			NSObjDetailsEditPrivate.f_hide_edit_section();
			NSObjDetails.f_show_read_section();
			//NSPageHeaderToolbar.f_o_dd_draw_clear_onclick();
            NSToolDraw.f_disable();
		},
		
		f_execute_delete: function()
		{
			var this_ = this;
			
			var o_edit_elements_state_functions = NSObjDetailsEditPrivate.o_edit_elements_state_functions;
		
			var b_button_active = o_edit_elements_state_functions.f_button_delete_is_enabled();
			
			if (!b_button_active)
			{
				return;
			}
			
			o_edit_elements_state_functions.f_button_delete_disable();
			o_edit_elements_state_functions.f_button_save_disable();	
			o_edit_elements_state_functions.f_button_cancel_disable();
			
			
			NSObjDetailsEditPrivate.o_delete_struct.f_show_dialog();
			
			//NSPageHeaderToolbar.f_o_dd_draw_clear_onclick();
            NSToolDraw.f_disable();
			
			
		},
		
		f_encode_string: function(s_in)
		{
			var s_res = s_in;
			
			if(s_in == "")
				return "__NULL__";
			
			s_res = NSFunctions.StringReplaceAll (s_res, "," , "__COMMA__");
			s_res = NSFunctions.StringReplaceAll (s_res, "," , "__COLON__");
			s_res = NSFunctions.StringReplaceAll (s_res, "http://" , "__HTTPLINK__");
			s_res = NSFunctions.StringReplaceAll (s_res, "https://" , "__HTTPSLINK__");

			return s_res;
			
		},
		
		f_decode_string: function(  )
		{
		},
		
		
		o_geometry: {
			private_objs: 
			{
				a_o_GeometryEditControl: [] // array that contains a references to all o_GeometryEditControl objects
			},
			/*
			o_in
			{
				s_schema_internal_name,
				s_table_internal_name,
				s_field_internal_name
			}
			*/
			f_create_edit_geometry_control: function(o_in)
			{
				var this_ = this;
				var private_objs = this.private_objs;
				var a_o_GeometryEditControl = private_objs.a_o_GeometryEditControl;

				let s_label_obj_details_edit_button_edit_tooltip = 			NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_button_edit_tooltip");
				let s_obj_details_edit_button_union_tooltip = 				NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_button_union_tooltip");
				let s_label_obj_details_edit_button_intersection_tooltip = 	NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_button_intersection_tooltip");
				let s_label_obj_details_edit_button_paste_tooltip = 		NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_button_paste_tooltip");

				var e_ = document.createElement("button");
				e_.setAttribute("type", "button");
				e_.setAttribute("class", "btn btn-sm btn-outline-secondary");
				e_.setAttribute("title", s_label_obj_details_edit_button_edit_tooltip);
				e_.innerHTML = PencilFillIcon;
				var e_button_edit = e_;
					
				var e_ = document.createElement("button");
				e_.setAttribute("type", "button");
				e_.setAttribute("class", "btn btn-sm btn-outline-secondary");
				e_.setAttribute("title", s_obj_details_edit_button_union_tooltip);
				e_.innerHTML = PlusIcon;
				var e_button_union= e_;
				
				var e_ = document.createElement("button");
				e_.setAttribute("type", "button");
				e_.setAttribute("class", "btn btn-sm btn-outline-secondary");
				e_.setAttribute("title", s_label_obj_details_edit_button_intersection_tooltip);
				e_.innerHTML = DashIcon;
				var e_button_intersection = e_;
				
				e_ = document.createElement("button");
				e_.setAttribute("type", "button");
				e_.setAttribute("class", "btn btn-sm btn-outline-secondary");
				e_.innerHTML = CheckIcon;
				var e_button_ok = e_;
				
				e_ = document.createElement("button");
				e_.setAttribute("type", "button");
				e_.setAttribute("class", "btn btn-sm btn-outline-secondary");
				e_.innerHTML = CloseIcon;
				var e_button_cancel = e_;
				
				e_ = document.createElement("button");
				e_.setAttribute("type", "button");
				e_.setAttribute("class", "btn btn-sm btn-outline-secondary");
				e_.setAttribute("title", s_label_obj_details_edit_button_paste_tooltip);
				e_.innerHTML = PasteIcon;
				var e_button_paste = e_;
				
				e_ = document.createElement("div");
				var e_div_geom = e_;
				
				
				
				e_div_geom.appendChild(e_button_edit);
				
				if(!NSObjDetailsEditPrivate.private_objs.o_details.feature.isNew) {
					e_div_geom.appendChild(e_button_union);
					e_div_geom.appendChild(e_button_intersection);
					
					let o_button_struct = NSObjDetailsEditPrivate.o_button_struct;
					o_button_struct.f_set_button_displayed_state(e_button_union, false);
					o_button_struct.f_set_button_displayed_state(e_button_intersection, false);
				}

				{
					e_div_geom.appendChild(e_button_union);
					e_div_geom.appendChild(e_button_intersection);
					

					this.f_show_buttons_union_intersection_if_applicable(
						o_in.s_schema_internal_name, 
						o_in.s_table_internal_name, 
						o_in.s_field_internal_name, 
						e_button_union, e_button_intersection);
						
				}

				e_div_geom.appendChild(e_button_ok);
				e_div_geom.appendChild(e_button_cancel);
				
				e_div_geom.appendChild(e_button_paste);
				
						
				var s_guid = "obj_details_edit_geometry_edit_control_" + NSFunctions.guidGenerator();
				var s_guid_original_geometry = "obj_details_edit_original_geometry" + NSFunctions.guidGenerator();
				
				var o_GeometryEditControl_in = {
					guid: s_guid,
					guid_original_geometry: s_guid_original_geometry,
					
					e_div_geom: e_div_geom,
					e_button_edit: e_button_edit,
					e_button_union : e_button_union,
					e_button_intersection: e_button_intersection,
					e_button_ok: e_button_ok,
					e_button_cancel: e_button_cancel,
					e_button_paste: e_button_paste
				};
				let o_GeometryEditControl = new NSObjDetailsEditPrivate.objs.GeometryEditControl(o_GeometryEditControl_in);
				a_o_GeometryEditControl.push(o_GeometryEditControl);
				
				var o_click_in = {
						s_schema_internal_name: o_in.s_schema_internal_name,
						s_table_internal_name: o_in.s_table_internal_name,
						s_field_internal_name: o_in.s_field_internal_name,
						o_GeometryEditControl: o_GeometryEditControl,

                        NSObjDetailsEditPrivate_ref: NSObjDetailsEditPrivate
					}
					
				e_button_edit.onclick = function()
				{
					if(o_click_in.union)
						{ delete o_click_in.union; }
					if(o_click_in.intersection)
						{ delete o_click_in.intersection; }
					
					this_.f_edit_click(o_click_in);
				}
				e_button_union.onclick = function()
				{
					o_click_in.union = true
					if(o_click_in.intersection)
						{ delete o_click_in.intersection; }

					this_.f_edit_click(o_click_in);
				},
				e_button_intersection.onclick = function()
				{
					if(o_click_in.union)
						{ delete o_click_in.union; }
					o_click_in.intersection = true

					this_.f_edit_click(o_click_in);
				},
				e_button_ok.onclick = function()
				{
					this_.f_ok_click(o_click_in);
				}
				e_button_cancel.onclick = function()
				{
					if(o_click_in.union)
						{ delete o_click_in.union; }
					if(o_click_in.intersection)
						{ delete o_click_in.intersection; }
					
					this_.f_cancel_click(o_click_in);
				}
				
				e_button_paste.onclick = function()
				{					
					this_.f_paste_click(o_click_in);
				}
				
				var o_button_struct = NSObjDetailsEditPrivate.o_button_struct;
				var b_is_displayed = false;
				o_button_struct.f_set_button_displayed_state(e_button_ok, b_is_displayed);
				o_button_struct.f_set_button_displayed_state(e_button_cancel, b_is_displayed);
				o_button_struct.f_set_button_displayed_state(e_button_paste, b_is_displayed);
				
				return o_GeometryEditControl;
			},
			f_disable_all_geometry_editions: function()
			{
				var private_objs = this.private_objs;
				var a_o_GeometryEditControl = private_objs.a_o_GeometryEditControl;
				var o_button_struct = NSObjDetailsEditPrivate.o_button_struct;
				
				for (var i=0; i<a_o_GeometryEditControl.length; i++)
				{
					var o_GeometryEditControl_i = a_o_GeometryEditControl[i];
					var e_button_edit_i = o_GeometryEditControl_i.e_button_edit;
					if(o_button_struct.f_button_is_active(e_button_edit_i))
					{
						var e_button_cancel_i = o_GeometryEditControl_i.e_button_cancel;
						e_button_cancel_i.onclick();
					}
					
				}
				
			},
			f_show_buttons_union_intersection_if_applicable: function(
				s_schema_internal_name, s_table_internal_name, s_field_internal_name, 
				e_button_union, e_button_intersection)
			{
				
				let o_col_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
				let s_geometry_type = o_col_info.data_type;
				let private_objs_global = NSObjDetailsEditPrivate.private_objs;
				let o_details_edit = private_objs_global.o_details_edit;
				let o_geojson_feature_geometry = o_details_edit.f_get_edit_field_value(s_field_internal_name);   //GeoJson Geometry

				let b_button_union_visible = false;
				let b_button_intersect_visible = false;


				// empty geometry - makes no sense to have union and intersect buttons
				if( !NSGeoJson.f_geojson_geometry_has_content(o_geojson_feature_geometry) ) //(o_geojson_feature_geometry == null)
				{
					b_button_union_visible = false;
					b_button_intersect_visible = false;
				}
				// generic geometry
				else if( NSDataTypes.f_geometry_type_is_generic(s_geometry_type) )
				{
					if ( NSGeoJson.f_geojson_feature_geometry_is_of_type_point(o_geojson_feature_geometry) 
					|| NSGeoJson.f_geojson_feature_geometry_is_of_type_polyline(o_geojson_feature_geometry) )
					{
						b_button_union_visible = true;			// generic geometry - leaving multi open
						b_button_intersect_visible = false;
					}
					else if ( NSGeoJson.f_geojson_feature_geometry_is_of_type_multipoint(o_geojson_feature_geometry)
					|| NSGeoJson.f_geojson_feature_geometry_is_of_type_multipolyline(o_geojson_feature_geometry))
					{
						b_button_union_visible = true;
						b_button_intersect_visible = false;
					}
					else if ( NSGeoJson.f_geojson_feature_geometry_is_of_type_polygon(o_geojson_feature_geometry) )
					{
						b_button_union_visible = true;			// generic geometry - leaving multi open
						b_button_intersect_visible = true;
					}
					else if ( NSGeoJson.f_geojson_feature_geometry_is_of_type_multipolygon(o_geojson_feature_geometry) )
					{
						b_button_union_visible = true;
						b_button_intersect_visible = true;
					}
				}
				// single point
				else if( NSDataTypes.f_geometry_type_is_point(s_geometry_type) 
					&& !NSDataTypes.f_geometry_type_is_multipoint(s_geometry_type) )
				{
					b_button_union_visible = false;
					b_button_intersect_visible = false;
				}
				// single linestring
				else if ( NSDataTypes.f_geometry_type_is_polyline(s_geometry_type) 
					&& !NSDataTypes.f_geometry_type_is_multilinestring(s_geometry_type) )
				{
					b_button_union_visible = false;
					b_button_intersect_visible = false;
				}
				// single polygon
				else if ( NSDataTypes.f_geometry_type_is_polygon(s_geometry_type) 
					&& !NSDataTypes.f_geometry_type_is_multipolygon(s_geometry_type) )
				{
					b_button_union_visible = false;
					b_button_intersect_visible = true;
				}
				// multipoint
				else if( NSDataTypes.f_geometry_type_is_multipoint(s_geometry_type) )
				{
					b_button_union_visible = true;
					b_button_intersect_visible = false;
				}
				// multilinestring
				else if( NSDataTypes.f_geometry_type_is_multilinestring(s_geometry_type) )
				{
					b_button_union_visible = true;
					b_button_intersect_visible = false;
				}
				// multipolygon
				else if( NSDataTypes.f_geometry_type_is_multipolygon(s_geometry_type) )
				{
					b_button_union_visible = true;
					b_button_intersect_visible = true;
				}
				
				let o_button_struct = NSObjDetailsEditPrivate.o_button_struct;
				o_button_struct.f_set_button_displayed_state(e_button_union, b_button_union_visible);
				o_button_struct.f_set_button_displayed_state(e_button_intersection, b_button_intersect_visible);
					
			},
			
            /*
            o_in:
            {
                s_schema_internal_name,
                s_table_internal_name,
                s_field_internal_name,
                o_GeometryEditControl,
                union, 
                intersection, 
                NSObjDetailsEditPrivate_ref
            }
            */
			f_edit_click: function (o_in)
			{
			
                let NSObjDetailsEditPrivate_ref = o_in.NSObjDetailsEditPrivate_ref;
				var private_objs_global = NSObjDetailsEditPrivate_ref.private_objs;
				var o_details = private_objs_global.o_details;
                var o_details_edit = private_objs_global.o_details_edit;
				
				var o_button_struct = NSObjDetailsEditPrivate_ref.o_button_struct;
				let o_geo_highlight = private_objs_global.o_geo_highlight;
				var s_schema_internal_name = o_in.s_schema_internal_name;
				var s_table_internal_name = o_in.s_table_internal_name;
				var s_field_internal_name = o_in.s_field_internal_name;
				var e_button_edit = o_in.o_GeometryEditControl.e_button_edit;
				var e_button_union = o_in.o_GeometryEditControl.e_button_union;
				var e_button_intersection = o_in.o_GeometryEditControl.e_button_intersection;
				var e_button_ok = o_in.o_GeometryEditControl.e_button_ok;
				var e_button_cancel = o_in.o_GeometryEditControl.e_button_cancel;
				var e_button_paste = o_in.o_GeometryEditControl.e_button_paste;
				
                
                let o_col_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
				
				
				//1
				this.f_disable_all_geometry_editions();
				//2
				var b_active = true;
				o_button_struct.f_set_button_active_state(e_button_edit, b_active);
				var b_is_displayed = false;
				o_button_struct.f_set_button_displayed_state(e_button_edit, b_is_displayed);
				o_button_struct.f_set_button_displayed_state(e_button_union, false);
				o_button_struct.f_set_button_displayed_state(e_button_intersection, false);
				
				//3
				b_is_displayed = true;
				o_button_struct.f_set_button_displayed_state(e_button_ok, b_is_displayed);
				o_button_struct.f_set_button_displayed_state(e_button_cancel, b_is_displayed);
				
				if( NSGeometryClipboard.f_b_clipboard_geometry_exists_and_is_compatible_with_specified_db_geometry_type(o_col_info.data_type) ) {
					o_button_struct.f_set_button_displayed_state(e_button_paste, b_is_displayed);
				}
				
				//4
				/*
					**
					->currently using previous edited and accepted but unsaved value, 
						if the field wasn't edited the changes structure will still be holding the original value
				*/
				//var o_geojson_feature_geometry = o_details_edit.f_get_original_field_value(s_field_internal_name);
				var o_geojson_feature_geometry = o_details_edit.f_get_edit_field_value(s_field_internal_name);   //GeoJson Geometry
				
				//o_in : {s_guid, urn, o_geojson_feature_geometry, style}
				var s_feature_urn = o_details_edit.s_urn;
	
				//if( !o_in.union && !o_in.intersection )
                {
					let s_guid = o_in.o_GeometryEditControl.guid_original_geometry; 
					let b_is_icon = false;
					let a_icon_size_xy = null; 
					/*
                    var o_geo_in = {
						s_guid: o_in.o_GeometryEditControl.guid_original_geometry,
						urn: s_feature_urn,
						o_geojson_feature_geometry: o_geojson_feature_geometry,
						//style: o_style,
						b_is_icon: o_details.b_is_icon,
						a_icon_size_xy: o_details.a_icon_size_xy	//[width, height]
						
					}
					*/
					let o_style_simple = new NSObjDetailsGeo.objs.GeoHighlightStyleSimpleIn({
						b_add_displacement_to_highlight_an_icon: 
							xCoreHelper.f_use_icon_auto_vetical_displacement() && b_is_icon,
						a_icon_size_xy: a_icon_size_xy	//[width, height]
					});

					let o_geo_in = new NSObjDetailsGeo.objs.AddFromGeojsonGeometryIn({
						s_guid: s_guid,
						urn: s_feature_urn,
						o_geojson_feature_geometry: o_geojson_feature_geometry,
						style_simple: o_style_simple						
					});
                    o_geo_highlight.f_add_from_geojson_geometry(o_geo_in);

                }
				
				if( !o_in.union && !o_in.intersection )
				{
					this.f_add_geometry_to_drawtool_for_edition(o_col_info, o_geojson_feature_geometry);
				}
				else
				{
					this.f_add_geometry_to_drawtool_for_edition(o_col_info, null);
				}
                			
			},
			f_add_geometry_to_drawtool_for_edition (o_col_info, o_geojson_feature_geometry)
			{

                //AQUIIII TO DO TODO More complex geometries            -> ex: o_geojson_feature_geometry.type != "MultiPolygon"
				var s_geometry_type = o_col_info.data_type;
				if(NSDataTypes.f_geometry_type_is_point(s_geometry_type))
				{
					NSToolDraw.f_draw_marker_enable(o_geojson_feature_geometry);
				}
				else if(NSDataTypes.f_geometry_type_is_polyline(s_geometry_type))
				{
					NSToolDraw.f_draw_polyline_enable(o_geojson_feature_geometry);
				}
				else //if (NSDataTypes.f_geometry_type_is_polygon(s_geometry_type))
				{
					/* doesn't work because openlayers, when starts to draw a new polygon destroys empty multipolygon and returns a polygon
					if(o_geojson_feature_geometry == null
						&& NSDataTypes.f_geometry_type_is_multipolygon(s_geometry_type))
					{
						o_geojson_feature_geometry = NSGeoJson.f_get_empty_geojson_feature_geometry_of_type_multipolygon();
					}
					*/
				
					//for polygon and multipolygon
					NSToolDraw.f_draw_polygon_enable(o_geojson_feature_geometry);
				}

			},
            /*
            o_in:
            {
                s_schema_internal_name,
                s_table_internal_name,
                s_field_internal_name,
                o_GeometryEditControl,
                union,
                intersection,
                NSObjDetailsEditPrivate_ref
            }
            */
			f_ok_click: function (o_in)
			{
				let NSObjDetailsEditPrivate_ref = o_in.NSObjDetailsEditPrivate_ref;
				var private_objs_global = NSObjDetailsEditPrivate_ref.private_objs;
				var o_details_edit = private_objs_global.o_details_edit;
				
				var o_button_struct = NSObjDetailsEditPrivate_ref.o_button_struct;
                var o_geo_highlight = private_objs_global.o_geo_highlight;
				var s_schema_internal_name = o_in.s_schema_internal_name;
				var s_table_internal_name = o_in.s_table_internal_name;
				var s_field_internal_name = o_in.s_field_internal_name;
				var e_button_edit = o_in.o_GeometryEditControl.e_button_edit;
				var e_button_union = o_in.o_GeometryEditControl.e_button_union;
				var e_button_intersection = o_in.o_GeometryEditControl.e_button_intersection;
				var e_button_ok = o_in.o_GeometryEditControl.e_button_ok;
				var e_button_cancel = o_in.o_GeometryEditControl.e_button_cancel;
				var e_button_paste = o_in.o_GeometryEditControl.e_button_paste;
				
                let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);		

				//1
				var b_geometry_is_valid;
				var s_geometry_type = o_field_info_i.data_type;
				
				if( NSDataTypes.f_geometry_type_is_generic(s_geometry_type) )
				{
					b_geometry_is_valid = 
					NSToolDraw.f_draw_marker_is_active_and_a_marker_is_drawn_or_empty() ||
					NSToolDraw.f_draw_polyline_is_active_and_a_line_is_drawn_or_empty() ||
					NSToolDraw.f_draw_polygon_is_active_and_an_area_is_drawn_or_empty();
				}
				else if( NSDataTypes.f_geometry_type_is_point(s_geometry_type) )
				{
					b_geometry_is_valid = NSToolDraw.f_draw_marker_is_active_and_a_marker_is_drawn_or_empty();
				}
				else if (NSDataTypes.f_geometry_type_is_polyline(s_geometry_type) )
				{
					b_geometry_is_valid = NSToolDraw.f_draw_polyline_is_active_and_a_line_is_drawn_or_empty();
				}
				else
				{
					b_geometry_is_valid = NSToolDraw.f_draw_polygon_is_active_and_an_area_is_drawn_or_empty();
				}
				
				if(!b_geometry_is_valid)
				{
					let s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_geometry_check_error");
					NSMessages.f_show_information(s_message);
					return;
				}
				
				//2
				var b_is_displayed = false;
				o_button_struct.f_set_button_displayed_state(e_button_ok, b_is_displayed);
				o_button_struct.f_set_button_displayed_state(e_button_cancel, b_is_displayed);
				o_button_struct.f_set_button_displayed_state(e_button_paste, b_is_displayed);
				
				// this function is to undo the hiding of the buttons (done above), when there's an invalid geometry
				let f_local_reset_geom_edit_mode_buttons = function() 
				{
					let b_is_displayed = true;
					o_button_struct.f_set_button_displayed_state(e_button_ok, b_is_displayed);
					o_button_struct.f_set_button_displayed_state(e_button_cancel, b_is_displayed);
					if( NSGeometryClipboard.f_b_clipboard_geometry_exists_and_is_compatible_with_specified_db_geometry_type(o_field_info_i.data_type) ) {
						o_button_struct.f_set_button_displayed_state(e_button_paste, b_is_displayed);
					}
					
				}

				//3
				//var o_field_geo_value = o_details_edit.f_get_edit_field_value(s_field_internal_name);

                let o_gj_feature = NSToolDraw_.f_get_drawn_geometry_as_geo_json_feature();
				let o_field_geo_value = (o_gj_feature!=null)? o_gj_feature.geometry : null;
				if(o_field_geo_value != null
					&& NSDataTypes.f_geometry_type_is_multipolygon(s_geometry_type)
					&& NSGeoJson.f_geojson_feature_geometry_is_of_type_polygon(o_field_geo_value)
				)
				{
					let o_geojson_feature_geometry_polygon = o_field_geo_value; 
					o_field_geo_value = NSGeoJson.f_get_geojson_feature_geometry_of_type_multipolygon_from_polygon(o_geojson_feature_geometry_polygon);
				}
				else if(o_field_geo_value != null
					&& NSDataTypes.f_geometry_type_is_multilinestring(s_geometry_type)
					&& NSGeoJson.f_geojson_feature_geometry_is_of_type_polyline(o_field_geo_value)
				)
				{
					let o_geojson_feature_geometry_polygon = o_field_geo_value; 
					o_field_geo_value = NSGeoJson.f_get_geojson_feature_geometry_of_type_multipolyline_from_polyline(o_geojson_feature_geometry_polygon);
				}
				else if(o_field_geo_value != null
					&& NSDataTypes.f_geometry_type_is_multipoint(s_geometry_type)
					&& NSGeoJson.f_geojson_feature_geometry_is_of_type_point(o_field_geo_value)
				)
				{
					let o_geojson_feature_geometry_polygon = o_field_geo_value; 
					o_field_geo_value = NSGeoJson.f_get_geojson_feature_geometry_of_type_multipoint_from_point(o_geojson_feature_geometry_polygon);
				}
					
                /*
					"UNION" / "INTERSECTION"
                */
				if(o_in.union)
				{
					if(o_field_geo_value == null)
					{         
						let s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_geometry_check_error");
						NSMessages.f_show_information(s_message);
						f_local_reset_geom_edit_mode_buttons();
						return;
					}
					let o_geojson_feature_geometry = o_details_edit.f_get_edit_field_value(s_field_internal_name);

					o_field_geo_value = NSGeoJson.f_get_geojson_union(o_geojson_feature_geometry, o_field_geo_value);

					if(o_field_geo_value == null) // union was not valid / successful
					{         
						let s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_geometry_check_error");
						NSMessages.f_show_information(s_message);
						f_local_reset_geom_edit_mode_buttons();
						return;
					}
				}
				else if(o_in.intersection)
				{
					if(o_field_geo_value == null)
					{         
						let s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_geometry_check_error");
						NSMessages.f_show_information(s_message);
						f_local_reset_geom_edit_mode_buttons();
						return;
					}
					let o_geojson_feature_geometry = o_details_edit.f_get_edit_field_value(s_field_internal_name);

					o_field_geo_value = NSGeoJson.f_get_geojson_intersect(o_geojson_feature_geometry, o_field_geo_value);
					
					if(o_field_geo_value == null)	// intersect was not valid / successful
					{         
						let s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_geometry_check_error");
						NSMessages.f_show_information(s_message);
						f_local_reset_geom_edit_mode_buttons();
						return;
					}
				}

				// Second geometry validation - for polygons and multipolygons - to check holes are valid despite changes to geometry
				if(o_field_geo_value != null
					//&& (NSDataTypes.f_geometry_type_is_polygon(s_geometry_type)
					//	|| NSDataTypes.f_geometry_type_is_multipolygon(s_geometry_type) )				
					&& NSGeoJson.f_geojson_feature_geometry_is_of_type_polygon_or_multipolygon(o_field_geo_value)
				)
				{
					// Parse the GeoJSON using OpenLayers
					//const geojsonFormat = new GeoJSON();
					//const o_field_geo_GeoJSON = geojsonFormat.writeGeometryObject(o_field_geo_value);
					const o_field_geo_GeoJSON = JSON.stringify(o_field_geo_value); // o_field_geo_value is a GeoJSON

					if( NSGeoJson.f_geojson_feature_geometry_is_of_type_polygon(o_field_geo_value) )
					{
						b_geometry_is_valid = NSGeoJson.f_geojson_polygon_is_valid(o_field_geo_GeoJSON);
					}
					else if( NSGeoJson.f_geojson_feature_geometry_is_of_type_multipolygon(o_field_geo_value) )
					{
						b_geometry_is_valid = NSGeoJson.f_geojson_multi_polygon_is_valid(o_field_geo_GeoJSON);
					}

					if(!b_geometry_is_valid)
					{
						let s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_geometry_check_error");
						NSMessages.f_show_information(s_message);

						// Show Geometry Edit Mode Buttons again
						f_local_reset_geom_edit_mode_buttons();
						
						return;
					}
				}

				o_details_edit.f_set_edit_field_value(s_field_internal_name, o_field_geo_value);
				
				//4
				var s_guid = o_in.o_GeometryEditControl.guid_original_geometry;
                o_geo_highlight.f_remove(s_guid);
				
				//5
				//NSPageHeaderToolbar.f_o_dd_draw_clear_onclick();
				{
					// to add updated geometry to draw tool
					this.f_add_geometry_to_drawtool_for_edition (o_field_info_i, o_field_geo_value); 
				}
				NSToolDraw.f_set_as_draft();
				
				
				//6 - set buttons visibility
				var b_active = false;
				o_button_struct.f_set_button_active_state(e_button_edit, b_active);
				var b_is_displayed = true;
				o_button_struct.f_set_button_displayed_state(e_button_edit, b_is_displayed);
				
				this.f_show_buttons_union_intersection_if_applicable(
					s_schema_internal_name, 
					s_table_internal_name, 
					s_field_internal_name, 
					e_button_union, e_button_intersection);
										
			},
             /*
            o_in:
            {
                s_schema_internal_name,
                s_table_internal_name,
                s_field_internal_name,
                o_GeometryEditControl,
                union, 
                intersection, 
                NSObjDetailsEditPrivate_ref
            }
            */		
			f_cancel_click: function (o_in)
			{
				/*
					1-hide "ok" and "cancel" buttons
					2-hide original polygon
					3-turn geometry editor off
					4-show edit button and remove active state
				*/
                let NSObjDetailsEditPrivate_ref = o_in.NSObjDetailsEditPrivate_ref;
				var private_objs_global = NSObjDetailsEditPrivate_ref.private_objs;
				var o_details_edit = private_objs_global.o_details_edit;
				
				var o_button_struct = NSObjDetailsEditPrivate_ref.o_button_struct;
                var o_geo_highlight = private_objs_global.o_geo_highlight;
				var s_schema_internal_name = o_in.s_schema_internal_name;
				var s_table_internal_name = o_in.s_table_internal_name;
				var s_field_internal_name = o_in.s_field_internal_name;
				var e_button_edit = o_in.o_GeometryEditControl.e_button_edit;
				var e_button_union= o_in.o_GeometryEditControl.e_button_union;
				var e_button_intersection = o_in.o_GeometryEditControl.e_button_intersection;
				var e_button_ok = o_in.o_GeometryEditControl.e_button_ok;
				var e_button_cancel = o_in.o_GeometryEditControl.e_button_cancel;
				var e_button_paste = o_in.o_GeometryEditControl.e_button_paste;
				
                let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
				
				
				//1
				var b_is_displayed = false;
				o_button_struct.f_set_button_displayed_state(e_button_ok, b_is_displayed);
				o_button_struct.f_set_button_displayed_state(e_button_cancel, b_is_displayed);
				o_button_struct.f_set_button_displayed_state(e_button_paste, b_is_displayed);
				
				//2
				var s_guid = o_in.o_GeometryEditControl.guid_original_geometry;
                o_geo_highlight.f_remove(s_guid);
				
				//3
				//NSPageHeaderToolbar.f_o_dd_draw_clear_onclick();
				//NSToolDraw.f_set_as_draft();
                NSToolDraw.f_disable();
				
				//4
				var b_active = false;
				o_button_struct.f_set_button_active_state(e_button_edit, b_active);
				var b_is_displayed = true;
				o_button_struct.f_set_button_displayed_state(e_button_edit, b_is_displayed);
				this.f_show_buttons_union_intersection_if_applicable(
					s_schema_internal_name, s_table_internal_name, s_field_internal_name, 
					e_button_union, e_button_intersection );
					
			},
            /*
            o_in:
            {
                s_schema_internal_name,
                s_table_internal_name,
                s_field_internal_name,
                o_GeometryEditControl,
                union, 
                intersection, 
                NSObjDetailsEditPrivate_ref
            }
            */
			f_paste_click: function (o_in){
				
				let s_schema_internal_name = o_in.s_schema_internal_name;
				let s_table_internal_name = o_in.s_table_internal_name;
				let s_field_internal_name = o_in.s_field_internal_name;
				
                let o_col_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);

				//let o_geojson_feature_geometry = NSGeometryClipboard.f_get_geometry();
				let s_geometry_type = o_col_info.data_type;
				let o_geojson_feature_geometry = NSGeometryClipboard.f_get_geometry_as_geometry_of_type(s_geometry_type)

				this.f_add_geometry_to_drawtool_for_edition (o_col_info, o_geojson_feature_geometry)
				
				let s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_paste_message");
				NSMessages.f_show_information(s_message , 3000);	
			}
		},
		
		/*
			o_field_schema_info -> field must be of join type, parent table internal name will be the internal_name
		*/
		f_boolean__creating_child_mode_and_field_is_parent: function (o_field_info_i)
		{
			let b_res = false;

			if(o_field_info_i.is_join)
			{
				let b_field_is_parent = o_field_info_i.is_fk;
				if(b_field_is_parent)
				{
					let s_urn_parent = NSObjDetailsEditPrivate.private_objs.s_urn_parent;
					let b_creating_child = (s_urn_parent!=null && s_urn_parent!="")? true : false;
					if (b_creating_child)
					{
						let s_parent_table_urn = NSURN.f_create_table_urn_from_record_urn(s_urn_parent);
						let s_external_table_urn = NSURN.f_create_table_urn_from_column_urn(o_field_info_i.external_col_urn); //o_field_info_i.external_col_urn -> column urn
	
						let b_field_i_is_parent = (s_parent_table_urn == s_external_table_urn)? true : false;
						b_res = b_field_i_is_parent;
					}
				}
	
				if(b_res)
				{
					//console.log("------------------------------------>, edition in creating child mode, and field join is parent ");
				}
			}
			
			
			return b_res;
		}
	},
	
	/*

	*/
	
	o_validate : 
	{
		f_s_is_number: function (s)
		{
			var b_res = (isNaN(s) || s=="" )? false: true;
			return b_res;
		},
		
		f_s_is_int: function (s)
		{
			var b_res = (isNaN(s) || s.indexOf(".")>-1 || s=="" )? false: true;
			return b_res;
		},

		f_date_is_valid: function(s_date)
		{
			var b_date_is_valid = true;
			
			var a_dt = s_date.split("-");
			if (a_dt.length != 3){b_date_is_valid = false;}
			if(b_date_is_valid)
			{
				
				var s_year = a_dt[0];
				var s_month = a_dt[1];
				var s_day = a_dt[2];
				
				if (!this.f_s_is_int(s_day)){b_date_is_valid = false;}
				if (!this.f_s_is_int(s_month)){b_date_is_valid = false;}
				if (!this.f_s_is_int(s_year)){b_date_is_valid = false;}
				if(b_date_is_valid)
				{
					var i_day = parseInt(s_day);
					var i_month = parseInt(s_month);
					var i_year = parseInt(s_year);
					
					//new Date(year, month, day, hours, minutes, seconds, milliseconds) 
					try { 

					  // create the date object with the values sent in (month is zero based)
					  var dt = new Date(i_year,i_month-1,i_day,0,0,0,0);

					  // get the month, day, and year from the object we just created 
					  var mon = dt.getMonth() + 1;
					  var day = dt.getDate();
					  var yr  = dt.getYear() + 1900;

					  // if they match then the date is valid
					  if ( mon == i_month && yr == i_year && day == i_day )
					  {
						b_date_is_valid = true;
					  }
					  else
					  {
						b_date_is_valid = false;
					  }
				   }
				   catch(e) {
					  b_date_is_valid = false;
				   }
				}
			}
			return b_date_is_valid;
			
			
		}
	},
	
	o_button_struct: 
	{
		f_button_is_active: function(e_button)
		{
			var sClass = 'active';
			var sClassesList = e_button.getAttribute('class');
			
			var b_is_active = NSFunctions.elemClass_HasClass(sClassesList, sClass);
			return b_is_active;
		},
		f_button_is_disabled: function(e_button)
		{
			var b_disabled = e_button.hasAttribute('disabled');
			return b_disabled;
		},
		f_button_is_displayed: function(e_button)
		{
			var sClass = 'd-none';
			var sClassesList = e_button.getAttribute('class');
			
			var b_is_active = NSFunctions.elemClass_HasClass(sClassesList, sClass);
			return b_is_active;
		},
		f_set_button_active_state: function(e_button, b_active)
		{
			var sClass = 'active';
			var sClassesList = e_button.getAttribute('class');
			
			if(b_active){
				sClassesList = NSFunctions.elemClass_addClass(sClassesList, sClass)
			}
			else{
				sClassesList = NSFunctions.elemClass_RemoveClass(sClassesList, sClass)
			}
			e_button.setAttribute('class', sClassesList);
		},
		f_set_button_disabled_state: function(e_button, b_disabled)
		{
			var s_attribute = 'disabled';
			if(b_disabled)
			{
				e_button.addAttribute(s_attribute, s_attribute);
			}
			else
			{
				e_button.removeAttribute(s_attribute);
			}
		},
		f_set_button_displayed_state: function(e_button, b_is_displayed)
		{
			var sClass = 'd-none';
			var sClassesList = e_button.getAttribute('class');
			
			if(b_is_displayed){
				sClassesList = NSFunctions.elemClass_RemoveClass(sClassesList, sClass);
			}
			else{
				sClassesList = NSFunctions.elemClass_addClass(sClassesList, sClass)
			}
			e_button.setAttribute('class', sClassesList);
		}
		
	},
	
	
	objs: {
		/*
		//o_obj_details like the object ("o_obj_details") created in "infowindow.js" that is passed to the function "f_open_details" in "object_details.js"
		o_obj_details = {
			s_urn,
			bbox: o_bbox,
			feature: o_feature,
			joined_object_counts: o_joined_object_counts,
		};
		
		ObjInfo = 
		{
			s_urn,
			feature
			{
				//urn,
				name,					//external table name
				properties,				//original object properties, each property key is the property external_name
				properties_complete,	//original object properties, each property key is the property external_name, ****-> BUT UNFILEDD PROPERTIES HAVE BEEN ADDED FROM SCHEMA 
				changes:
				{
					b_data_changed	//indicates if there has been any change to object data
					properties		//object properties may be updated with changes, each property key is the property external_name
				}
			}
		}
		
		*/
		ObjInfo: function (o_obj_details)
		{
			let o_obj_details_feature_in = o_obj_details.feature;
			
			this.s_urn = o_obj_details.s_urn;
			this.feature = {
				id: o_obj_details_feature_in.id,
				//urn: o_obj_details_feature_in.urn,
				name: o_obj_details_feature_in.name,
				
				properties: {},
				
				properties_complete: {},
				
				changes: {
					b_data_changed: false,
					properties: {}
				}
			}
			
			let s_feature_urn = this.s_urn;
			let a_feature_urn_info = NSURN.f_get_urn_info(s_feature_urn);
			let s_schema_internal_name = a_feature_urn_info[1];
			let s_table_internal_name = a_feature_urn_info[2];
            let o_col_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);

            //let a_column_info = o_col_info.a_column_info;
            let a_column_info_original = o_col_info.extra.a_column_info_original;
            a_column_info_original.forEach( o_field_i => {
				let internal_name = o_field_i.internal_name;
				
				this.feature.properties_complete[internal_name] = null;
				this.feature.changes.properties[internal_name] = null;
            });
            
			let a_feature_property_key = Object.keys(o_obj_details_feature_in.properties);
            a_feature_property_key.forEach(s_key_i => {
				this.feature.properties[s_key_i] = o_obj_details_feature_in.properties[s_key_i];
				this.feature.properties_complete[s_key_i] = o_obj_details_feature_in.properties[s_key_i];
				this.feature.changes.properties[s_key_i] = o_obj_details_feature_in.properties[s_key_i];
                
            });
			
		},
		
		/*
			o_in
			{
					s_schema_internal_name,
					s_table_internal_name,
					s_field_internal_name,
                    s_field_i_internal_name_db,
					s_field_external_name,		// field external name
					e_edit_element,				//document element that allows field edit: input, checkbox, select,...
					e_tr,						//table row element (tr)
					o_GeometryEditControl		//	not null if field is of type geometry
					o_ParentJoinEditControl		//	not null if field is of type parent join - {NSObjDetailsEditPrivate.objs.ParentJoinEditControl}
			}
		*/
		FieldEdit: function(o_in)
		{
			this.s_schema_internal_name = o_in.s_schema_internal_name;
			this.s_table_internal_name = o_in.s_table_internal_name;
			this.s_field_internal_name = o_in.s_field_internal_name;
            this.s_field_i_internal_name_db = o_in.s_field_i_internal_name_db,
			this.s_field_external_name = o_in.s_field_external_name;
			this.e_edit_element = o_in.e_edit_element;
			this.e_tr = o_in.e_tr;
			this.o_GeometryEditControl = o_in.o_GeometryEditControl;
			this.o_ParentJoinEditControl = o_in.o_ParentJoinEditControl;
			
			this.b_changed = false;
			
		},
		/*
			o_in
			{
				e_div_geom: e_div_geom,
				e_button_edit: e_button_edit,
				e_button_ok: e_button_ok,
				e_button_cancel: e_button_cancel
			}
		*/
		GeometryEditControl: function(o_in)
		{
			this.guid = o_in.guid;
			this.guid_original_geometry = o_in.guid;
			this.e_div_geom = o_in.e_div_geom;
			this.e_button_edit = o_in.e_button_edit;
			this.e_button_union = o_in.e_button_union;
			this.e_button_intersection= o_in.e_button_intersection;
			this.e_button_ok = o_in.e_button_ok;
			this.e_button_cancel = o_in.e_button_cancel;
			this.e_button_paste = o_in.e_button_paste;
			
		},
		/*
			o_in
			{
				e_div: e_div,
				e_button_switch_parent: e_button_switch_parent
			}
		*/
		ParentJoinEditControl: function(o_in)
		{
			this.e_div = o_in.e_div;
			this.e_button_switch_parent = o_in.e_button_switch_parent;
		},
		
		init: function()
		{
			this.ObjInfo.prototype.f_get_original_field_value = function(s_field_internal_name)
			{
				var value = this.feature.properties[s_field_internal_name];
				return value;
			}
			
			this.ObjInfo.prototype.f_get_edit_field_value = function(s_field_internal_name)
			{
				var value = this.feature.changes.properties[s_field_internal_name];
				return value;
			}
			
			this.ObjInfo.prototype.f_set_edit_field_value = function(s_field_internal_name, o_new_value)
			{
				this.feature.changes.b_data_changed = true;
				this.feature.changes.properties[s_field_internal_name] = o_new_value;
			}
		}
		
	}


}